/* eslint-disable */
/*
 * This combined file was created by the DataTables downloader builder:
 *   https://datatables.net/download
 *
 * To rebuild or modify this file with the latest versions of the included
 * software please visit:
 *   https://datatables.net/download/#bs5/dt-1.12.1
 *
 * Included libraries:
 *  DataTables 1.12.1
 */

/*!
   SpryMedia Ltd.

 This source file is free software, available under the following license:
   MIT license - http://datatables.net/license

 This source file is distributed in the hope that it will be useful, but
 WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
 or FITNESS FOR A PARTICULAR PURPOSE. See the license files for details.

 For details please refer to: http://www.datatables.net
 DataTables 1.12.1
 ©2008-2022 SpryMedia Ltd - datatables.net/license
*/
var $jscomp = $jscomp || {}
$jscomp.scope = {}
$jscomp.findInternal = function (l, y, A) {
  l instanceof String && (l = String(l))
  for (let q = l.length, E = 0; E < q; E++) {
    const P = l[E]
    if (y.call(A, P, E, l)) return { i: E, v: P }
  }
  return { i: -1, v: void 0 }
}
$jscomp.ASSUME_ES5 = !1
$jscomp.ASSUME_NO_NATIVE_MAP = !1
$jscomp.ASSUME_NO_NATIVE_SET = !1
$jscomp.SIMPLE_FROUND_POLYFILL = !1
$jscomp.ISOLATE_POLYFILLS = !1
$jscomp.defineProperty =
  $jscomp.ASSUME_ES5 || typeof Object.defineProperties === 'function'
    ? Object.defineProperty
    : function (l, y, A) {
        if (l == Array.prototype || l == Object.prototype) return l
        l[y] = A.value
        return l
      }
$jscomp.getGlobal = function (l) {
  l = [
    typeof globalThis === 'object' && globalThis,
    l,
    typeof window === 'object' && window,
    typeof self === 'object' && self,
    typeof global === 'object' && global,
  ]
  for (let y = 0; y < l.length; ++y) {
    const A = l[y]
    if (A && A.Math == Math) return A
  }
  throw Error('Cannot find global object')
}
$jscomp.global = $jscomp.getGlobal(this)
$jscomp.IS_SYMBOL_NATIVE =
  typeof Symbol === 'function' && typeof Symbol('x') === 'symbol'
$jscomp.TRUST_ES6_POLYFILLS =
  !$jscomp.ISOLATE_POLYFILLS || $jscomp.IS_SYMBOL_NATIVE
$jscomp.polyfills = {}
$jscomp.propertyToPolyfillSymbol = {}
$jscomp.POLYFILL_PREFIX = '$jscp$'
var $jscomp$lookupPolyfilledValue = function (l, y) {
  let A = $jscomp.propertyToPolyfillSymbol[y]
  if (A == null) return l[y]
  A = l[A]
  return void 0 !== A ? A : l[y]
}
$jscomp.polyfill = function (l, y, A, q) {
  y &&
    ($jscomp.ISOLATE_POLYFILLS
      ? $jscomp.polyfillIsolated(l, y, A, q)
      : $jscomp.polyfillUnisolated(l, y, A, q))
}
$jscomp.polyfillUnisolated = function (l, y, A, q) {
  A = $jscomp.global
  l = l.split('.')
  for (q = 0; q < l.length - 1; q++) {
    const E = l[q]
    if (!(E in A)) return
    A = A[E]
  }
  l = l[l.length - 1]
  q = A[l]
  y = y(q)
  y != q &&
    y != null &&
    $jscomp.defineProperty(A, l, { configurable: !0, writable: !0, value: y })
}
$jscomp.polyfillIsolated = function (l, y, A, q) {
  let E = l.split('.')
  l = E.length === 1
  q = E[0]
  q = !l && q in $jscomp.polyfills ? $jscomp.polyfills : $jscomp.global
  for (let P = 0; P < E.length - 1; P++) {
    const la = E[P]
    if (!(la in q)) return
    q = q[la]
  }
  E = E[E.length - 1]
  A = $jscomp.IS_SYMBOL_NATIVE && A === 'es6' ? q[E] : null
  y = y(A)
  y != null &&
    (l
      ? $jscomp.defineProperty($jscomp.polyfills, E, {
          configurable: !0,
          writable: !0,
          value: y,
        })
      : y !== A &&
        (($jscomp.propertyToPolyfillSymbol[E] = $jscomp.IS_SYMBOL_NATIVE
          ? $jscomp.global.Symbol(E)
          : $jscomp.POLYFILL_PREFIX + E),
        (E = $jscomp.propertyToPolyfillSymbol[E]),
        $jscomp.defineProperty(q, E, {
          configurable: !0,
          writable: !0,
          value: y,
        })))
}
$jscomp.polyfill(
  'Array.prototype.find',
  function (l) {
    return (
      l ||
      function (y, A) {
        return $jscomp.findInternal(this, y, A).v
      }
    )
  },
  'es6',
  'es3',
)
;(function (l) {
  typeof define === 'function' && define.amd
    ? define(['jquery'], function (y) {
        return l(y, window, document)
      })
    : typeof exports === 'object'
    ? (module.exports = function (y, A) {
        y || (y = window)
        A ||
          (A =
            typeof window !== 'undefined'
              ? require('jquery')
              : require('jquery')(y))
        return l(A, y, y.document)
      })
    : (window.DataTable = l(jQuery, window, document))
})(function (l, y, A, q) {
  function E(a) {
    let b
    let c
    const d = {}
    l.each(a, function (e, h) {
      ;(b = e.match(/^([^A-Z]+?)([A-Z])/)) &&
        'a aa ai ao as b fn i m o s '.indexOf(`${b[1]} `) !== -1 &&
        ((c = e.replace(b[0], b[2].toLowerCase())),
        (d[c] = e),
        b[1] === 'o' && E(a[e]))
    })
    a._hungarianMap = d
  }
  function P(a, b, c) {
    a._hungarianMap || E(a)
    let d
    l.each(b, function (e, h) {
      d = a._hungarianMap[e]
      d === q ||
        (!c && b[d] !== q) ||
        (d.charAt(0) === 'o'
          ? (b[d] || (b[d] = {}), l.extend(!0, b[d], b[e]), P(a[d], b[d], c))
          : (b[d] = b[e]))
    })
  }
  function la(a) {
    const b = u.defaults.oLanguage
    const c = b.sDecimal
    c && bb(c)
    if (a) {
      const d = a.sZeroRecords
      !a.sEmptyTable &&
        d &&
        b.sEmptyTable === 'No data available in table' &&
        Y(a, a, 'sZeroRecords', 'sEmptyTable')
      !a.sLoadingRecords &&
        d &&
        b.sLoadingRecords === 'Loading...' &&
        Y(a, a, 'sZeroRecords', 'sLoadingRecords')
      a.sInfoThousands && (a.sThousands = a.sInfoThousands)
      ;(a = a.sDecimal) && c !== a && bb(a)
    }
  }
  function Db(a) {
    S(a, 'ordering', 'bSort')
    S(a, 'orderMulti', 'bSortMulti')
    S(a, 'orderClasses', 'bSortClasses')
    S(a, 'orderCellsTop', 'bSortCellsTop')
    S(a, 'order', 'aaSorting')
    S(a, 'orderFixed', 'aaSortingFixed')
    S(a, 'paging', 'bPaginate')
    S(a, 'pagingType', 'sPaginationType')
    S(a, 'pageLength', 'iDisplayLength')
    S(a, 'searching', 'bFilter')
    typeof a.sScrollX === 'boolean' && (a.sScrollX = a.sScrollX ? '100%' : '')
    typeof a.scrollX === 'boolean' && (a.scrollX = a.scrollX ? '100%' : '')
    if ((a = a.aoSearchCols))
      for (let b = 0, c = a.length; b < c; b++)
        a[b] && P(u.models.oSearch, a[b])
  }
  function Eb(a) {
    S(a, 'orderable', 'bSortable')
    S(a, 'orderData', 'aDataSort')
    S(a, 'orderSequence', 'asSorting')
    S(a, 'orderDataType', 'sortDataType')
    const b = a.aDataSort
    typeof b !== 'number' || Array.isArray(b) || (a.aDataSort = [b])
  }
  function Fb(a) {
    if (!u.__browser) {
      const b = {}
      u.__browser = b
      const c = l('<div/>')
        .css({
          position: 'fixed',
          top: 0,
          left: -1 * l(y).scrollLeft(),
          height: 1,
          width: 1,
          overflow: 'hidden',
        })
        .append(
          l('<div/>')
            .css({
              position: 'absolute',
              top: 1,
              left: 1,
              width: 100,
              overflow: 'scroll',
            })
            .append(l('<div/>').css({ width: '100%', height: 10 })),
        )
        .appendTo('body')
      const d = c.children()
      const e = d.children()
      b.barWidth = d[0].offsetWidth - d[0].clientWidth
      b.bScrollOversize = e[0].offsetWidth === 100 && d[0].clientWidth !== 100
      b.bScrollbarLeft = Math.round(e.offset().left) !== 1
      b.bBounding = c[0].getBoundingClientRect().width ? !0 : !1
      c.remove()
    }
    l.extend(a.oBrowser, u.__browser)
    a.oScroll.iBarWidth = u.__browser.barWidth
  }
  function Gb(a, b, c, d, e, h) {
    let f = !1
    if (c !== q) {
      var g = c
      f = !0
    }
    for (; d !== e; )
      a.hasOwnProperty(d) &&
        ((g = f ? b(g, a[d], d, a) : a[d]), (f = !0), (d += h))
    return g
  }
  function cb(a, b) {
    let c = u.defaults.column
    const d = a.aoColumns.length
    c = l.extend({}, u.models.oColumn, c, {
      nTh: b || A.createElement('th'),
      sTitle: c.sTitle ? c.sTitle : b ? b.innerHTML : '',
      aDataSort: c.aDataSort ? c.aDataSort : [d],
      mData: c.mData ? c.mData : d,
      idx: d,
    })
    a.aoColumns.push(c)
    c = a.aoPreSearchCols
    c[d] = l.extend({}, u.models.oSearch, c[d])
    Ia(a, d, l(b).data())
  }
  function Ia(a, b, c) {
    b = a.aoColumns[b]
    const d = a.oClasses
    const e = l(b.nTh)
    if (!b.sWidthOrig) {
      b.sWidthOrig = e.attr('width') || null
      var h = (e.attr('style') || '').match(/width:\s*(\d+[pxem%]+)/)
      h && (b.sWidthOrig = h[1])
    }
    c !== q &&
      c !== null &&
      (Eb(c),
      P(u.defaults.column, c, !0),
      c.mDataProp === q || c.mData || (c.mData = c.mDataProp),
      c.sType && (b._sManualType = c.sType),
      c.className && !c.sClass && (c.sClass = c.className),
      c.sClass && e.addClass(c.sClass),
      (h = b.sClass),
      l.extend(b, c),
      Y(b, c, 'sWidth', 'sWidthOrig'),
      h !== b.sClass && (b.sClass = `${h} ${b.sClass}`),
      c.iDataSort !== q && (b.aDataSort = [c.iDataSort]),
      Y(b, c, 'aDataSort'))
    const f = b.mData
    const g = ma(f)
    const k = b.mRender ? ma(b.mRender) : null
    c = function (m) {
      return typeof m === 'string' && m.indexOf('@') !== -1
    }
    b._bAttrSrc = l.isPlainObject(f) && (c(f.sort) || c(f.type) || c(f.filter))
    b._setter = null
    b.fnGetData = function (m, n, p) {
      const t = g(m, n, q, p)
      return k && n ? k(t, n, m, p) : t
    }
    b.fnSetData = function (m, n, p) {
      return ha(f)(m, n, p)
    }
    typeof f !== 'number' && (a._rowReadObject = !0)
    a.oFeatures.bSort || ((b.bSortable = !1), e.addClass(d.sSortableNone))
    a = l.inArray('asc', b.asSorting) !== -1
    c = l.inArray('desc', b.asSorting) !== -1
    b.bSortable && (a || c)
      ? a && !c
        ? ((b.sSortingClass = d.sSortableAsc),
          (b.sSortingClassJUI = d.sSortJUIAscAllowed))
        : !a && c
        ? ((b.sSortingClass = d.sSortableDesc),
          (b.sSortingClassJUI = d.sSortJUIDescAllowed))
        : ((b.sSortingClass = d.sSortable), (b.sSortingClassJUI = d.sSortJUI))
      : ((b.sSortingClass = d.sSortableNone), (b.sSortingClassJUI = ''))
  }
  function sa(a) {
    if (!1 !== a.oFeatures.bAutoWidth) {
      var b = a.aoColumns
      db(a)
      for (let c = 0, d = b.length; c < d; c++)
        b[c].nTh.style.width = b[c].sWidth
    }
    b = a.oScroll
    ;(b.sY === '' && b.sX === '') || Ja(a)
    F(a, null, 'column-sizing', [a])
  }
  function ta(a, b) {
    a = Ka(a, 'bVisible')
    return typeof a[b] === 'number' ? a[b] : null
  }
  function ua(a, b) {
    a = Ka(a, 'bVisible')
    b = l.inArray(b, a)
    return b !== -1 ? b : null
  }
  function na(a) {
    let b = 0
    l.each(a.aoColumns, function (c, d) {
      d.bVisible && l(d.nTh).css('display') !== 'none' && b++
    })
    return b
  }
  function Ka(a, b) {
    const c = []
    l.map(a.aoColumns, function (d, e) {
      d[b] && c.push(e)
    })
    return c
  }
  function eb(a) {
    const b = a.aoColumns
    const c = a.aoData
    const d = u.ext.type.detect
    let e
    let h
    let f
    let g = 0
    for (e = b.length; g < e; g++) {
      const k = b[g]
      const m = []
      if (!k.sType && k._sManualType) k.sType = k._sManualType
      else if (!k.sType) {
        let n = 0
        for (h = d.length; n < h; n++) {
          let p = 0
          for (f = c.length; p < f; p++) {
            m[p] === q && (m[p] = T(a, p, g, 'type'))
            var t = d[n](m[p], a)
            if (!t && n !== d.length - 1) break
            if (t === 'html' && !aa(m[p])) break
          }
          if (t) {
            k.sType = t
            break
          }
        }
        k.sType || (k.sType = 'string')
      }
    }
  }
  function Hb(a, b, c, d) {
    let e
    let h
    let f
    const g = a.aoColumns
    if (b)
      for (e = b.length - 1; e >= 0; e--) {
        const k = b[e]
        let m =
          k.target !== q ? k.target : k.targets !== q ? k.targets : k.aTargets
        Array.isArray(m) || (m = [m])
        let n = 0
        for (h = m.length; n < h; n++)
          if (typeof m[n] === 'number' && m[n] >= 0) {
            for (; g.length <= m[n]; ) cb(a)
            d(m[n], k)
          } else if (typeof m[n] === 'number' && m[n] < 0) d(g.length + m[n], k)
          else if (typeof m[n] === 'string') {
            let p = 0
            for (f = g.length; p < f; p++)
              (m[n] == '_all' || l(g[p].nTh).hasClass(m[n])) && d(p, k)
          }
      }
    if (c) for (e = 0, a = c.length; e < a; e++) d(e, c[e])
  }
  function ia(a, b, c, d) {
    const e = a.aoData.length
    const h = l.extend(!0, {}, u.models.oRow, {
      src: c ? 'dom' : 'data',
      idx: e,
    })
    h._aData = b
    a.aoData.push(h)
    for (let f = a.aoColumns, g = 0, k = f.length; g < k; g++) f[g].sType = null
    a.aiDisplayMaster.push(e)
    b = a.rowIdFn(b)
    b !== q && (a.aIds[b] = h)
    ;(!c && a.oFeatures.bDeferRender) || fb(a, e, c, d)
    return e
  }
  function La(a, b) {
    let c
    b instanceof l || (b = l(b))
    return b.map(function (d, e) {
      c = gb(a, e)
      return ia(a, c.data, e, c.cells)
    })
  }
  function T(a, b, c, d) {
    d === 'search' ? (d = 'filter') : d === 'order' && (d = 'sort')
    const e = a.iDraw
    const h = a.aoColumns[c]
    const f = a.aoData[b]._aData
    const g = h.sDefaultContent
    let k = h.fnGetData(f, d, { settings: a, row: b, col: c })
    if (k === q)
      return (
        a.iDrawError != e &&
          g === null &&
          (ea(
            a,
            0,
            `Requested unknown parameter ${
              typeof h.mData === 'function' ? '{function}' : `'${h.mData}'`
            } for row ${b}, column ${c}`,
            4,
          ),
          (a.iDrawError = e)),
        g
      )
    if ((k === f || k === null) && g !== null && d !== q) k = g
    else if (typeof k === 'function') return k.call(f)
    if (k === null && d === 'display') return ''
    d === 'filter' &&
      ((a = u.ext.type.search), a[h.sType] && (k = a[h.sType](k)))
    return k
  }
  function Ib(a, b, c, d) {
    a.aoColumns[c].fnSetData(a.aoData[b]._aData, d, {
      settings: a,
      row: b,
      col: c,
    })
  }
  function hb(a) {
    return l.map(a.match(/(\\.|[^\.])+/g) || [''], function (b) {
      return b.replace(/\\\./g, '.')
    })
  }
  function ib(a) {
    return U(a.aoData, '_aData')
  }
  function Ma(a) {
    a.aoData.length = 0
    a.aiDisplayMaster.length = 0
    a.aiDisplay.length = 0
    a.aIds = {}
  }
  function Na(a, b, c) {
    for (var d = -1, e = 0, h = a.length; e < h; e++)
      a[e] == b ? (d = e) : a[e] > b && a[e]--
    d != -1 && c === q && a.splice(d, 1)
  }
  function va(a, b, c, d) {
    const e = a.aoData[b]
    let h
    let f = function (k, m) {
      for (; k.childNodes.length; ) k.removeChild(k.firstChild)
      k.innerHTML = T(a, b, m, 'display')
    }
    if (c !== 'dom' && ((c && c !== 'auto') || e.src !== 'dom')) {
      const g = e.anCells
      if (g)
        if (d !== q) f(g[d], d)
        else for (c = 0, h = g.length; c < h; c++) f(g[c], c)
    } else e._aData = gb(a, e, d, d === q ? q : e._aData).data
    e._aSortData = null
    e._aFilterData = null
    f = a.aoColumns
    if (d !== q) f[d].sType = null
    else {
      c = 0
      for (h = f.length; c < h; c++) f[c].sType = null
      jb(a, e)
    }
  }
  function gb(a, b, c, d) {
    let e = []
    let h = b.firstChild
    let f
    let g = 0
    let k
    const m = a.aoColumns
    const n = a._rowReadObject
    d = d !== q ? d : n ? {} : []
    const p = function (x, w) {
      if (typeof x === 'string') {
        let r = x.indexOf('@')
        r !== -1 && ((r = x.substring(r + 1)), ha(x)(d, w.getAttribute(r)))
      }
    }
    const t = function (x) {
      if (c === q || c === g)
        (f = m[g]),
          (k = x.innerHTML.trim()),
          f && f._bAttrSrc
            ? (ha(f.mData._)(d, k),
              p(f.mData.sort, x),
              p(f.mData.type, x),
              p(f.mData.filter, x))
            : n
            ? (f._setter || (f._setter = ha(f.mData)), f._setter(d, k))
            : (d[g] = k)
      g++
    }
    if (h)
      for (; h; ) {
        var v = h.nodeName.toUpperCase()
        if (v == 'TD' || v == 'TH') t(h), e.push(h)
        h = h.nextSibling
      }
    else for (e = b.anCells, h = 0, v = e.length; h < v; h++) t(e[h])
    ;(b = b.firstChild ? b : b.nTr) &&
      (b = b.getAttribute('id')) &&
      ha(a.rowId)(d, b)
    return { data: d, cells: e }
  }
  function fb(a, b, c, d) {
    let e = a.aoData[b]
    const h = e._aData
    const f = []
    let g
    let k
    if (e.nTr === null) {
      const m = c || A.createElement('tr')
      e.nTr = m
      e.anCells = f
      m._DT_RowIndex = b
      jb(a, e)
      let n = 0
      for (g = a.aoColumns.length; n < g; n++) {
        const p = a.aoColumns[n]
        e = (k = c ? !1 : !0) ? A.createElement(p.sCellType) : d[n]
        e._DT_CellIndex = { row: b, column: n }
        f.push(e)
        if (
          k ||
          !(
            (!p.mRender && p.mData === n) ||
            (l.isPlainObject(p.mData) && p.mData._ === `${n}.display`)
          )
        )
          e.innerHTML = T(a, b, n, 'display')
        p.sClass && (e.className += ` ${p.sClass}`)
        p.bVisible && !c
          ? m.appendChild(e)
          : !p.bVisible && c && e.parentNode.removeChild(e)
        p.fnCreatedCell &&
          p.fnCreatedCell.call(a.oInstance, e, T(a, b, n), h, b, n)
      }
      F(a, 'aoRowCreatedCallback', null, [m, h, b, f])
    }
  }
  function jb(a, b) {
    const c = b.nTr
    const d = b._aData
    if (c) {
      if ((a = a.rowIdFn(d))) c.id = a
      d.DT_RowClass &&
        ((a = d.DT_RowClass.split(' ')),
        (b.__rowc = b.__rowc ? Oa(b.__rowc.concat(a)) : a),
        l(c).removeClass(b.__rowc.join(' ')).addClass(d.DT_RowClass))
      d.DT_RowAttr && l(c).attr(d.DT_RowAttr)
      d.DT_RowData && l(c).data(d.DT_RowData)
    }
  }
  function Jb(a) {
    let b
    let c
    const d = a.nTHead
    const e = a.nTFoot
    const h = l('th, td', d).length === 0
    const f = a.oClasses
    const g = a.aoColumns
    h && (c = l('<tr/>').appendTo(d))
    let k = 0
    for (b = g.length; k < b; k++) {
      var m = g[k]
      const n = l(m.nTh).addClass(m.sClass)
      h && n.appendTo(c)
      a.oFeatures.bSort &&
        (n.addClass(m.sSortingClass),
        !1 !== m.bSortable &&
          (n.attr('tabindex', a.iTabIndex).attr('aria-controls', a.sTableId),
          kb(a, m.nTh, k)))
      m.sTitle != n[0].innerHTML && n.html(m.sTitle)
      lb(a, 'header')(a, n, m, f)
    }
    h && wa(a.aoHeader, d)
    l(d).children('tr').children('th, td').addClass(f.sHeaderTH)
    l(e).children('tr').children('th, td').addClass(f.sFooterTH)
    if (e !== null)
      for (a = a.aoFooter[0], k = 0, b = a.length; k < b; k++)
        (m = g[k]), (m.nTf = a[k].cell), m.sClass && l(m.nTf).addClass(m.sClass)
  }
  function xa(a, b, c) {
    let d
    let e
    const h = []
    const f = []
    let g = a.aoColumns.length
    if (b) {
      c === q && (c = !1)
      let k = 0
      for (d = b.length; k < d; k++) {
        h[k] = b[k].slice()
        h[k].nTr = b[k].nTr
        for (e = g - 1; e >= 0; e--)
          a.aoColumns[e].bVisible || c || h[k].splice(e, 1)
        f.push([])
      }
      k = 0
      for (d = h.length; k < d; k++) {
        if ((a = h[k].nTr)) for (; (e = a.firstChild); ) a.removeChild(e)
        e = 0
        for (b = h[k].length; e < b; e++) {
          let m = (g = 1)
          if (f[k][e] === q) {
            a.appendChild(h[k][e].cell)
            for (
              f[k][e] = 1;
              h[k + g] !== q && h[k][e].cell == h[k + g][e].cell;

            )
              (f[k + g][e] = 1), g++
            for (; h[k][e + m] !== q && h[k][e].cell == h[k][e + m].cell; ) {
              for (c = 0; c < g; c++) f[k + c][e + m] = 1
              m++
            }
            l(h[k][e].cell).attr('rowspan', g).attr('colspan', m)
          }
        }
      }
    }
  }
  function ja(a, b) {
    let c = Q(a) == 'ssp'
    let d = a.iInitDisplayStart
    d !== q &&
      d !== -1 &&
      ((a._iDisplayStart = c ? d : d >= a.fnRecordsDisplay() ? 0 : d),
      (a.iInitDisplayStart = -1))
    c = F(a, 'aoPreDrawCallback', 'preDraw', [a])
    if (l.inArray(!1, c) !== -1) V(a, !1)
    else {
      c = []
      let e = 0
      d = a.asStripeClasses
      const h = d.length
      let f = a.oLanguage
      let g = Q(a) == 'ssp'
      const k = a.aiDisplay
      const m = a._iDisplayStart
      const n = a.fnDisplayEnd()
      a.bDrawing = !0
      if (a.bDeferLoading) (a.bDeferLoading = !1), a.iDraw++, V(a, !1)
      else if (!g) a.iDraw++
      else if (!a.bDestroying && !b) {
        Kb(a)
        return
      }
      if (k.length !== 0)
        for (b = g ? a.aoData.length : n, f = g ? 0 : m; f < b; f++) {
          g = k[f]
          const p = a.aoData[g]
          p.nTr === null && fb(a, g)
          const t = p.nTr
          if (h !== 0) {
            const v = d[e % h]
            p._sRowStripe != v &&
              (l(t).removeClass(p._sRowStripe).addClass(v), (p._sRowStripe = v))
          }
          F(a, 'aoRowCallback', null, [t, p._aData, e, f, g])
          c.push(t)
          e++
        }
      else
        (e = f.sZeroRecords),
          a.iDraw == 1 && Q(a) == 'ajax'
            ? (e = f.sLoadingRecords)
            : f.sEmptyTable && a.fnRecordsTotal() === 0 && (e = f.sEmptyTable),
          (c[0] = l('<tr/>', { class: h ? d[0] : '' }).append(
            l('<td />', {
              valign: 'top',
              colSpan: na(a),
              class: a.oClasses.sRowEmpty,
            }).html(e),
          )[0])
      F(a, 'aoHeaderCallback', 'header', [
        l(a.nTHead).children('tr')[0],
        ib(a),
        m,
        n,
        k,
      ])
      F(a, 'aoFooterCallback', 'footer', [
        l(a.nTFoot).children('tr')[0],
        ib(a),
        m,
        n,
        k,
      ])
      d = l(a.nTBody)
      d.children().detach()
      d.append(l(c))
      F(a, 'aoDrawCallback', 'draw', [a])
      a.bSorted = !1
      a.bFiltered = !1
      a.bDrawing = !1
    }
  }
  function ka(a, b) {
    const c = a.oFeatures
    const d = c.bFilter
    c.bSort && Lb(a)
    d ? ya(a, a.oPreviousSearch) : (a.aiDisplay = a.aiDisplayMaster.slice())
    !0 !== b && (a._iDisplayStart = 0)
    a._drawHold = b
    ja(a)
    a._drawHold = !1
  }
  function Mb(a) {
    const b = a.oClasses
    let c = l(a.nTable)
    c = l('<div/>').insertBefore(c)
    const d = a.oFeatures
    let e = l('<div/>', {
      id: `${a.sTableId}_wrapper`,
      class: b.sWrapper + (a.nTFoot ? '' : ` ${b.sNoFooter}`),
    })
    a.nHolding = c[0]
    a.nTableWrapper = e[0]
    a.nTableReinsertBefore = a.nTable.nextSibling
    for (var h = a.sDom.split(''), f, g, k, m, n, p, t = 0; t < h.length; t++) {
      f = null
      g = h[t]
      if (g == '<') {
        k = l('<div/>')[0]
        m = h[t + 1]
        if (m == "'" || m == '"') {
          n = ''
          for (p = 2; h[t + p] != m; ) (n += h[t + p]), p++
          n == 'H' ? (n = b.sJUIHeader) : n == 'F' && (n = b.sJUIFooter)
          n.indexOf('.') != -1
            ? ((m = n.split('.')),
              (k.id = m[0].substr(1, m[0].length - 1)),
              (k.className = m[1]))
            : n.charAt(0) == '#'
            ? (k.id = n.substr(1, n.length - 1))
            : (k.className = n)
          t += p
        }
        e.append(k)
        e = l(k)
      } else if (g == '>') e = e.parent()
      else if (g == 'l' && d.bPaginate && d.bLengthChange) f = Nb(a)
      else if (g == 'f' && d.bFilter) f = Ob(a)
      else if (g == 'r' && d.bProcessing) f = Pb(a)
      else if (g == 't') f = Qb(a)
      else if (g == 'i' && d.bInfo) f = Rb(a)
      else if (g == 'p' && d.bPaginate) f = Sb(a)
      else if (u.ext.feature.length !== 0)
        for (k = u.ext.feature, p = 0, m = k.length; p < m; p++)
          if (g == k[p].cFeature) {
            f = k[p].fnInit(a)
            break
          }
      f && ((k = a.aanFeatures), k[g] || (k[g] = []), k[g].push(f), e.append(f))
    }
    c.replaceWith(e)
    a.nHolding = null
  }
  function wa(a, b) {
    b = l(b).children('tr')
    let c
    let d
    let e
    a.splice(0, a.length)
    let h = 0
    for (e = b.length; h < e; h++) a.push([])
    h = 0
    for (e = b.length; h < e; h++) {
      const f = b[h]
      for (c = f.firstChild; c; ) {
        if (
          c.nodeName.toUpperCase() == 'TD' ||
          c.nodeName.toUpperCase() == 'TH'
        ) {
          let g = 1 * c.getAttribute('colspan')
          let k = 1 * c.getAttribute('rowspan')
          g = g && g !== 0 && g !== 1 ? g : 1
          k = k && k !== 0 && k !== 1 ? k : 1
          let m = 0
          for (d = a[h]; d[m]; ) m++
          const n = m
          const p = g === 1 ? !0 : !1
          for (d = 0; d < g; d++)
            for (m = 0; m < k; m++)
              (a[h + m][n + d] = { cell: c, unique: p }), (a[h + m].nTr = f)
        }
        c = c.nextSibling
      }
    }
  }
  function Pa(a, b, c) {
    const d = []
    c || ((c = a.aoHeader), b && ((c = []), wa(c, b)))
    b = 0
    for (let e = c.length; b < e; b++)
      for (let h = 0, f = c[b].length; h < f; h++)
        !c[b][h].unique || (d[h] && a.bSortCellsTop) || (d[h] = c[b][h].cell)
    return d
  }
  function Qa(a, b, c) {
    F(a, 'aoServerParams', 'serverParams', [b])
    if (b && Array.isArray(b)) {
      const d = {}
      const e = /(.*?)\[\]$/
      l.each(b, function (n, p) {
        ;(n = p.name.match(e))
          ? ((n = n[0]), d[n] || (d[n] = []), d[n].push(p.value))
          : (d[p.name] = p.value)
      })
      b = d
    }
    const h = a.ajax
    const f = a.oInstance
    const g = function (n) {
      let p = a.jqXHR ? a.jqXHR.status : null
      if (n === null || (typeof p === 'number' && p == 204))
        (n = {}), za(a, n, [])
      ;(p = n.error || n.sError) && ea(a, 0, p)
      a.json = n
      F(a, null, 'xhr', [a, n, a.jqXHR])
      c(n)
    }
    if (l.isPlainObject(h) && h.data) {
      var k = h.data
      var m = typeof k === 'function' ? k(b, a) : k
      b = typeof k === 'function' && m ? m : l.extend(!0, b, m)
      delete h.data
    }
    m = {
      data: b,
      success: g,
      dataType: 'json',
      cache: !1,
      type: a.sServerMethod,
      error(n, p, t) {
        t = F(a, null, 'xhr', [a, null, a.jqXHR])
        l.inArray(!0, t) === -1 &&
          (p == 'parsererror'
            ? ea(a, 0, 'Invalid JSON response', 1)
            : n.readyState === 4 && ea(a, 0, 'Ajax error', 7))
        V(a, !1)
      },
    }
    a.oAjaxData = b
    F(a, null, 'preXhr', [a, b])
    a.fnServerData
      ? a.fnServerData.call(
          f,
          a.sAjaxSource,
          l.map(b, function (n, p) {
            return { name: p, value: n }
          }),
          g,
          a,
        )
      : a.sAjaxSource || typeof h === 'string'
      ? (a.jqXHR = l.ajax(l.extend(m, { url: h || a.sAjaxSource })))
      : typeof h === 'function'
      ? (a.jqXHR = h.call(f, b, g, a))
      : ((a.jqXHR = l.ajax(l.extend(m, h))), (h.data = k))
  }
  function Kb(a) {
    a.iDraw++
    V(a, !0)
    Qa(a, Tb(a), function (b) {
      Ub(a, b)
    })
  }
  function Tb(a) {
    let b = a.aoColumns
    const c = b.length
    const d = a.oFeatures
    const e = a.oPreviousSearch
    const h = a.aoPreSearchCols
    const f = []
    const g = oa(a)
    let k = a._iDisplayStart
    let m = !1 !== d.bPaginate ? a._iDisplayLength : -1
    const n = function (x, w) {
      f.push({ name: x, value: w })
    }
    n('sEcho', a.iDraw)
    n('iColumns', c)
    n('sColumns', U(b, 'sName').join(','))
    n('iDisplayStart', k)
    n('iDisplayLength', m)
    const p = {
      draw: a.iDraw,
      columns: [],
      order: [],
      start: k,
      length: m,
      search: { value: e.sSearch, regex: e.bRegex },
    }
    for (k = 0; k < c; k++) {
      const t = b[k]
      const v = h[k]
      m = typeof t.mData === 'function' ? 'function' : t.mData
      p.columns.push({
        data: m,
        name: t.sName,
        searchable: t.bSearchable,
        orderable: t.bSortable,
        search: { value: v.sSearch, regex: v.bRegex },
      })
      n(`mDataProp_${k}`, m)
      d.bFilter &&
        (n(`sSearch_${k}`, v.sSearch),
        n(`bRegex_${k}`, v.bRegex),
        n(`bSearchable_${k}`, t.bSearchable))
      d.bSort && n(`bSortable_${k}`, t.bSortable)
    }
    d.bFilter && (n('sSearch', e.sSearch), n('bRegex', e.bRegex))
    d.bSort &&
      (l.each(g, function (x, w) {
        p.order.push({ column: w.col, dir: w.dir })
        n(`iSortCol_${x}`, w.col)
        n(`sSortDir_${x}`, w.dir)
      }),
      n('iSortingCols', g.length))
    b = u.ext.legacy.ajax
    return b === null ? (a.sAjaxSource ? f : p) : b ? f : p
  }
  function Ub(a, b) {
    let c = function (f, g) {
      return b[f] !== q ? b[f] : b[g]
    }
    let d = za(a, b)
    let e = c('sEcho', 'draw')
    let h = c('iTotalRecords', 'recordsTotal')
    c = c('iTotalDisplayRecords', 'recordsFiltered')
    if (e !== q) {
      if (1 * e < a.iDraw) return
      a.iDraw = 1 * e
    }
    d || (d = [])
    Ma(a)
    a._iRecordsTotal = parseInt(h, 10)
    a._iRecordsDisplay = parseInt(c, 10)
    e = 0
    for (h = d.length; e < h; e++) ia(a, d[e])
    a.aiDisplay = a.aiDisplayMaster.slice()
    ja(a, !0)
    a._bInitComplete || Ra(a, b)
    V(a, !1)
  }
  function za(a, b, c) {
    a =
      l.isPlainObject(a.ajax) && a.ajax.dataSrc !== q
        ? a.ajax.dataSrc
        : a.sAjaxDataProp
    if (!c) return a === 'data' ? b.aaData || b[a] : a !== '' ? ma(a)(b) : b
    ha(a)(b, c)
  }
  function Ob(a) {
    let b = a.oClasses
    const c = a.sTableId
    const d = a.oLanguage
    const e = a.oPreviousSearch
    let h = a.aanFeatures
    const f = `<input type="search" class="${b.sFilterInput}"/>`
    let g = d.sSearch
    g = g.match(/_INPUT_/) ? g.replace('_INPUT_', f) : g + f
    b = l('<div/>', {
      id: h.f ? null : `${c}_filter`,
      class: b.sFilter,
    }).append(l('<label/>').append(g))
    const k = function (n) {
      const p = this.value ? this.value : ''
      ;(e.return && n.key !== 'Enter') ||
        p == e.sSearch ||
        (ya(a, {
          sSearch: p,
          bRegex: e.bRegex,
          bSmart: e.bSmart,
          bCaseInsensitive: e.bCaseInsensitive,
          return: e.return,
        }),
        (a._iDisplayStart = 0),
        ja(a))
    }
    h = a.searchDelay !== null ? a.searchDelay : Q(a) === 'ssp' ? 400 : 0
    var m = l('input', b)
      .val(e.sSearch)
      .attr('placeholder', d.sSearchPlaceholder)
      .on('keyup.DT search.DT input.DT paste.DT cut.DT', h ? mb(k, h) : k)
      .on('mouseup', function (n) {
        setTimeout(function () {
          k.call(m[0], n)
        }, 10)
      })
      .on('keypress.DT', function (n) {
        if (n.keyCode == 13) return !1
      })
      .attr('aria-controls', c)
    l(a.nTable).on('search.dt.DT', function (n, p) {
      if (a === p)
        try {
          m[0] !== A.activeElement && m.val(e.sSearch)
        } catch (t) {}
    })
    return b[0]
  }
  function ya(a, b, c) {
    const d = a.oPreviousSearch
    const e = a.aoPreSearchCols
    const h = function (g) {
      d.sSearch = g.sSearch
      d.bRegex = g.bRegex
      d.bSmart = g.bSmart
      d.bCaseInsensitive = g.bCaseInsensitive
      d.return = g.return
    }
    const f = function (g) {
      return g.bEscapeRegex !== q ? !g.bEscapeRegex : g.bRegex
    }
    eb(a)
    if (Q(a) != 'ssp') {
      Vb(a, b.sSearch, c, f(b), b.bSmart, b.bCaseInsensitive, b.return)
      h(b)
      for (b = 0; b < e.length; b++)
        Wb(a, e[b].sSearch, b, f(e[b]), e[b].bSmart, e[b].bCaseInsensitive)
      Xb(a)
    } else h(b)
    a.bFiltered = !0
    F(a, null, 'search', [a])
  }
  function Xb(a) {
    for (
      var b = u.ext.search, c = a.aiDisplay, d, e, h = 0, f = b.length;
      h < f;
      h++
    ) {
      for (var g = [], k = 0, m = c.length; k < m; k++)
        (e = c[k]),
          (d = a.aoData[e]),
          b[h](a, d._aFilterData, e, d._aData, k) && g.push(e)
      c.length = 0
      l.merge(c, g)
    }
  }
  function Wb(a, b, c, d, e, h) {
    if (b !== '') {
      const f = []
      const g = a.aiDisplay
      d = nb(b, d, e, h)
      for (e = 0; e < g.length; e++)
        (b = a.aoData[g[e]]._aFilterData[c]), d.test(b) && f.push(g[e])
      a.aiDisplay = f
    }
  }
  function Vb(a, b, c, d, e, h) {
    e = nb(b, d, e, h)
    const f = a.oPreviousSearch.sSearch
    const g = a.aiDisplayMaster
    h = []
    u.ext.search.length !== 0 && (c = !0)
    const k = Yb(a)
    if (b.length <= 0) a.aiDisplay = g.slice()
    else {
      if (k || c || d || f.length > b.length || b.indexOf(f) !== 0 || a.bSorted)
        a.aiDisplay = g.slice()
      b = a.aiDisplay
      for (c = 0; c < b.length; c++)
        e.test(a.aoData[b[c]]._sFilterRow) && h.push(b[c])
      a.aiDisplay = h
    }
  }
  function nb(a, b, c, d) {
    a = b ? a : ob(a)
    c &&
      (a = `^(?=.*?${l
        .map(a.match(/"[^"]+"|[^ ]+/g) || [''], function (e) {
          if (e.charAt(0) === '"') {
            const h = e.match(/^"(.*)"$/)
            e = h ? h[1] : e
          }
          return e.replace('"', '')
        })
        .join(')(?=.*?')}).*$`)
    return new RegExp(a, d ? 'i' : '')
  }
  function Yb(a) {
    const b = a.aoColumns
    let c
    let d
    let e = !1
    let h = 0
    for (c = a.aoData.length; h < c; h++) {
      const f = a.aoData[h]
      if (!f._aFilterData) {
        const g = []
        e = 0
        for (d = b.length; e < d; e++) {
          let k = b[e]
          k.bSearchable
            ? ((k = T(a, h, e, 'filter')),
              k === null && (k = ''),
              typeof k !== 'string' && k.toString && (k = k.toString()))
            : (k = '')
          k.indexOf &&
            k.indexOf('&') !== -1 &&
            ((Sa.innerHTML = k), (k = Bc ? Sa.textContent : Sa.innerText))
          k.replace && (k = k.replace(/[\r\n\u2028]/g, ''))
          g.push(k)
        }
        f._aFilterData = g
        f._sFilterRow = g.join('  ')
        e = !0
      }
    }
    return e
  }
  function Zb(a) {
    return {
      search: a.sSearch,
      smart: a.bSmart,
      regex: a.bRegex,
      caseInsensitive: a.bCaseInsensitive,
    }
  }
  function $b(a) {
    return {
      sSearch: a.search,
      bSmart: a.smart,
      bRegex: a.regex,
      bCaseInsensitive: a.caseInsensitive,
    }
  }
  function Rb(a) {
    const b = a.sTableId
    const c = a.aanFeatures.i
    const d = l('<div/>', {
      class: a.oClasses.sInfo,
      id: c ? null : `${b}_info`,
    })
    c ||
      (a.aoDrawCallback.push({ fn: ac, sName: 'information' }),
      d.attr('role', 'status').attr('aria-live', 'polite'),
      l(a.nTable).attr('aria-describedby', `${b}_info`))
    return d[0]
  }
  function ac(a) {
    const b = a.aanFeatures.i
    if (b.length !== 0) {
      let c = a.oLanguage
      const d = a._iDisplayStart + 1
      const e = a.fnDisplayEnd()
      const h = a.fnRecordsTotal()
      const f = a.fnRecordsDisplay()
      let g = f ? c.sInfo : c.sInfoEmpty
      f !== h && (g += ` ${c.sInfoFiltered}`)
      g += c.sInfoPostFix
      g = bc(a, g)
      c = c.fnInfoCallback
      c !== null && (g = c.call(a.oInstance, a, d, e, h, f, g))
      l(b).html(g)
    }
  }
  function bc(a, b) {
    const c = a.fnFormatNumber
    const d = a._iDisplayStart + 1
    const e = a._iDisplayLength
    const h = a.fnRecordsDisplay()
    const f = e === -1
    return b
      .replace(/_START_/g, c.call(a, d))
      .replace(/_END_/g, c.call(a, a.fnDisplayEnd()))
      .replace(/_MAX_/g, c.call(a, a.fnRecordsTotal()))
      .replace(/_TOTAL_/g, c.call(a, h))
      .replace(/_PAGE_/g, c.call(a, f ? 1 : Math.ceil(d / e)))
      .replace(/_PAGES_/g, c.call(a, f ? 1 : Math.ceil(h / e)))
  }
  function Aa(a) {
    const b = a.iInitDisplayStart
    let c = a.aoColumns
    let d = a.oFeatures
    const e = a.bDeferLoading
    if (a.bInitialised) {
      Mb(a)
      Jb(a)
      xa(a, a.aoHeader)
      xa(a, a.aoFooter)
      V(a, !0)
      d.bAutoWidth && db(a)
      let h = 0
      for (d = c.length; h < d; h++) {
        const f = c[h]
        f.sWidth && (f.nTh.style.width = K(f.sWidth))
      }
      F(a, null, 'preInit', [a])
      ka(a)
      c = Q(a)
      if (c != 'ssp' || e)
        c == 'ajax'
          ? Qa(
              a,
              [],
              function (g) {
                const k = za(a, g)
                for (h = 0; h < k.length; h++) ia(a, k[h])
                a.iInitDisplayStart = b
                ka(a)
                V(a, !1)
                Ra(a, g)
              },
              a,
            )
          : (V(a, !1), Ra(a))
    } else
      setTimeout(function () {
        Aa(a)
      }, 200)
  }
  function Ra(a, b) {
    a._bInitComplete = !0
    ;(b || a.oInit.aaData) && sa(a)
    F(a, null, 'plugin-init', [a, b])
    F(a, 'aoInitComplete', 'init', [a, b])
  }
  function pb(a, b) {
    b = parseInt(b, 10)
    a._iDisplayLength = b
    qb(a)
    F(a, null, 'length', [a, b])
  }
  function Nb(a) {
    const b = a.oClasses
    const c = a.sTableId
    let d = a.aLengthMenu
    let e = Array.isArray(d[0])
    const h = e ? d[0] : d
    d = e ? d[1] : d
    e = l('<select/>', {
      'name': `${c}_length`,
      'aria-controls': c,
      'class': b.sLengthSelect,
    })
    for (let f = 0, g = h.length; f < g; f++)
      e[0][f] = new Option(
        typeof d[f] === 'number' ? a.fnFormatNumber(d[f]) : d[f],
        h[f],
      )
    const k = l('<div><label/></div>').addClass(b.sLength)
    a.aanFeatures.l || (k[0].id = `${c}_length`)
    k.children().append(
      a.oLanguage.sLengthMenu.replace('_MENU_', e[0].outerHTML),
    )
    l('select', k)
      .val(a._iDisplayLength)
      .on('change.DT', function (m) {
        pb(a, l(this).val())
        ja(a)
      })
    l(a.nTable).on('length.dt.DT', function (m, n, p) {
      a === n && l('select', k).val(p)
    })
    return k[0]
  }
  function Sb(a) {
    let b = a.sPaginationType
    const c = u.ext.pager[b]
    const d = typeof c === 'function'
    const e = function (f) {
      ja(f)
    }
    b = l('<div/>').addClass(a.oClasses.sPaging + b)[0]
    const h = a.aanFeatures
    d || c.fnInit(a, b, e)
    h.p ||
      ((b.id = `${a.sTableId}_paginate`),
      a.aoDrawCallback.push({
        fn(f) {
          if (d) {
            let g = f._iDisplayStart
            let k = f._iDisplayLength
            let m = f.fnRecordsDisplay()
            let n = k === -1
            g = n ? 0 : Math.ceil(g / k)
            k = n ? 1 : Math.ceil(m / k)
            m = c(g, k)
            let p
            n = 0
            for (p = h.p.length; n < p; n++)
              lb(f, 'pageButton')(f, h.p[n], n, m, g, k)
          } else c.fnUpdate(f, e)
        },
        sName: 'pagination',
      }))
    return b
  }
  function Ta(a, b, c) {
    let d = a._iDisplayStart
    const e = a._iDisplayLength
    const h = a.fnRecordsDisplay()
    h === 0 || e === -1
      ? (d = 0)
      : typeof b === 'number'
      ? ((d = b * e), d > h && (d = 0))
      : b == 'first'
      ? (d = 0)
      : b == 'previous'
      ? ((d = e >= 0 ? d - e : 0), d < 0 && (d = 0))
      : b == 'next'
      ? d + e < h && (d += e)
      : b == 'last'
      ? (d = Math.floor((h - 1) / e) * e)
      : ea(a, 0, `Unknown paging action: ${b}`, 5)
    b = a._iDisplayStart !== d
    a._iDisplayStart = d
    b && (F(a, null, 'page', [a]), c && ja(a))
    return b
  }
  function Pb(a) {
    return l('<div/>', {
      id: a.aanFeatures.r ? null : `${a.sTableId}_processing`,
      class: a.oClasses.sProcessing,
    })
      .html(a.oLanguage.sProcessing)
      .append('<div><div></div><div></div><div></div><div></div></div>')
      .insertBefore(a.nTable)[0]
  }
  function V(a, b) {
    a.oFeatures.bProcessing &&
      l(a.aanFeatures.r).css('display', b ? 'block' : 'none')
    F(a, null, 'processing', [a, b])
  }
  function Qb(a) {
    let b = l(a.nTable)
    const c = a.oScroll
    if (c.sX === '' && c.sY === '') return a.nTable
    const d = c.sX
    const e = c.sY
    let h = a.oClasses
    const f = b.children('caption')
    const g = f.length ? f[0]._captionSide : null
    let k = l(b[0].cloneNode(!1))
    const m = l(b[0].cloneNode(!1))
    let n = b.children('tfoot')
    n.length || (n = null)
    k = l('<div/>', { class: h.sScrollWrapper })
      .append(
        l('<div/>', { class: h.sScrollHead })
          .css({
            overflow: 'hidden',
            position: 'relative',
            border: 0,
            width: d ? (d ? K(d) : null) : '100%',
          })
          .append(
            l('<div/>', { class: h.sScrollHeadInner })
              .css({
                'box-sizing': 'content-box',
                'width': c.sXInner || '100%',
              })
              .append(
                k
                  .removeAttr('id')
                  .css('margin-left', 0)
                  .append(g === 'top' ? f : null)
                  .append(b.children('thead')),
              ),
          ),
      )
      .append(
        l('<div/>', { class: h.sScrollBody })
          .css({
            position: 'relative',
            overflow: 'auto',
            width: d ? K(d) : null,
          })
          .append(b),
      )
    n &&
      k.append(
        l('<div/>', { class: h.sScrollFoot })
          .css({
            overflow: 'hidden',
            border: 0,
            width: d ? (d ? K(d) : null) : '100%',
          })
          .append(
            l('<div/>', { class: h.sScrollFootInner }).append(
              m
                .removeAttr('id')
                .css('margin-left', 0)
                .append(g === 'bottom' ? f : null)
                .append(b.children('tfoot')),
            ),
          ),
      )
    b = k.children()
    const p = b[0]
    h = b[1]
    const t = n ? b[2] : null
    if (d)
      l(h).on('scroll.DT', function (v) {
        v = this.scrollLeft
        p.scrollLeft = v
        n && (t.scrollLeft = v)
      })
    l(h).css('max-height', e)
    c.bCollapse || l(h).css('height', e)
    a.nScrollHead = p
    a.nScrollBody = h
    a.nScrollFoot = t
    a.aoDrawCallback.push({ fn: Ja, sName: 'scrolling' })
    return k[0]
  }
  function Ja(a) {
    let b = a.oScroll
    let c = b.sX
    let d = b.sXInner
    let e = b.sY
    b = b.iBarWidth
    let h = l(a.nScrollHead)
    const f = h[0].style
    let g = h.children('div')
    const k = g[0].style
    const m = g.children('table')
    g = a.nScrollBody
    const n = l(g)
    const p = g.style
    const t = l(a.nScrollFoot).children('div')
    const v = t.children('table')
    let x = l(a.nTHead)
    const w = l(a.nTable)
    const r = w[0]
    const C = r.style
    const G = a.nTFoot ? l(a.nTFoot) : null
    const ba = a.oBrowser
    const L = ba.bScrollOversize
    U(a.aoColumns, 'nTh')
    const O = []
    const I = []
    const H = []
    const fa = []
    let Z
    const Ba = function (D) {
      D = D.style
      D.paddingTop = '0'
      D.paddingBottom = '0'
      D.borderTopWidth = '0'
      D.borderBottomWidth = '0'
      D.height = 0
    }
    let X = g.scrollHeight > g.clientHeight
    if (a.scrollBarVis !== X && a.scrollBarVis !== q)
      (a.scrollBarVis = X), sa(a)
    else {
      a.scrollBarVis = X
      w.children('thead, tfoot').remove()
      if (G) {
        X = G.clone().prependTo(w)
        var ca = G.find('tr')
        var Ca = X.find('tr')
        X.find('[id]').removeAttr('id')
      }
      const Ua = x.clone().prependTo(w)
      x = x.find('tr')
      X = Ua.find('tr')
      Ua.find('th, td').removeAttr('tabindex')
      Ua.find('[id]').removeAttr('id')
      c || ((p.width = '100%'), (h[0].style.width = '100%'))
      l.each(Pa(a, Ua), function (D, W) {
        Z = ta(a, D)
        W.style.width = a.aoColumns[Z].sWidth
      })
      G &&
        da(function (D) {
          D.style.width = ''
        }, Ca)
      h = w.outerWidth()
      c === ''
        ? ((C.width = '100%'),
          L &&
            (w.find('tbody').height() > g.offsetHeight ||
              n.css('overflow-y') == 'scroll') &&
            (C.width = K(w.outerWidth() - b)),
          (h = w.outerWidth()))
        : d !== '' && ((C.width = K(d)), (h = w.outerWidth()))
      da(Ba, X)
      da(function (D) {
        const W = y.getComputedStyle
          ? y.getComputedStyle(D).width
          : K(l(D).width())
        H.push(D.innerHTML)
        O.push(W)
      }, X)
      da(function (D, W) {
        D.style.width = O[W]
      }, x)
      l(X).css('height', 0)
      G &&
        (da(Ba, Ca),
        da(function (D) {
          fa.push(D.innerHTML)
          I.push(K(l(D).css('width')))
        }, Ca),
        da(function (D, W) {
          D.style.width = I[W]
        }, ca),
        l(Ca).height(0))
      da(function (D, W) {
        D.innerHTML = `<div class="dataTables_sizing">${H[W]}</div>`
        D.childNodes[0].style.height = '0'
        D.childNodes[0].style.overflow = 'hidden'
        D.style.width = O[W]
      }, X)
      G &&
        da(function (D, W) {
          D.innerHTML = `<div class="dataTables_sizing">${fa[W]}</div>`
          D.childNodes[0].style.height = '0'
          D.childNodes[0].style.overflow = 'hidden'
          D.style.width = I[W]
        }, Ca)
      Math.round(w.outerWidth()) < Math.round(h)
        ? ((ca =
            g.scrollHeight > g.offsetHeight || n.css('overflow-y') == 'scroll'
              ? h + b
              : h),
          L &&
            (g.scrollHeight > g.offsetHeight ||
              n.css('overflow-y') == 'scroll') &&
            (C.width = K(ca - b)),
          (c !== '' && d === '') || ea(a, 1, 'Possible column misalignment', 6))
        : (ca = '100%')
      p.width = K(ca)
      f.width = K(ca)
      G && (a.nScrollFoot.style.width = K(ca))
      !e && L && (p.height = K(r.offsetHeight + b))
      c = w.outerWidth()
      m[0].style.width = K(c)
      k.width = K(c)
      d = w.height() > g.clientHeight || n.css('overflow-y') == 'scroll'
      e = `padding${ba.bScrollbarLeft ? 'Left' : 'Right'}`
      k[e] = d ? `${b}px` : '0px'
      G &&
        ((v[0].style.width = K(c)),
        (t[0].style.width = K(c)),
        (t[0].style[e] = d ? `${b}px` : '0px'))
      w.children('colgroup').insertBefore(w.children('thead'))
      n.trigger('scroll')
      ;(!a.bSorted && !a.bFiltered) || a._drawHold || (g.scrollTop = 0)
    }
  }
  function da(a, b, c) {
    for (var d = 0, e = 0, h = b.length, f, g; e < h; ) {
      f = b[e].firstChild
      for (g = c ? c[e].firstChild : null; f; )
        f.nodeType === 1 && (c ? a(f, g, d) : a(f, d), d++),
          (f = f.nextSibling),
          (g = c ? g.nextSibling : null)
      e++
    }
  }
  function db(a) {
    let b = a.nTable
    const c = a.aoColumns
    let d = a.oScroll
    let e = d.sY
    const h = d.sX
    let f = d.sXInner
    let g = c.length
    let k = Ka(a, 'bVisible')
    let m = l('th', a.nTHead)
    let n = b.getAttribute('width')
    let p = b.parentNode
    let t = !1
    let v
    const x = a.oBrowser
    d = x.bScrollOversize
    ;(v = b.style.width) && v.indexOf('%') !== -1 && (n = v)
    for (v = 0; v < k.length; v++) {
      var w = c[k[v]]
      w.sWidth !== null && ((w.sWidth = cc(w.sWidthOrig, p)), (t = !0))
    }
    if (d || (!t && !h && !e && g == na(a) && g == m.length))
      for (v = 0; v < g; v++)
        (k = ta(a, v)), k !== null && (c[k].sWidth = K(m.eq(v).width()))
    else {
      g = l(b).clone().css('visibility', 'hidden').removeAttr('id')
      g.find('tbody tr').remove()
      const r = l('<tr/>').appendTo(g.find('tbody'))
      g.find('thead, tfoot').remove()
      g.append(l(a.nTHead).clone()).append(l(a.nTFoot).clone())
      g.find('tfoot th, tfoot td').css('width', '')
      m = Pa(a, g.find('thead')[0])
      for (v = 0; v < k.length; v++)
        (w = c[k[v]]),
          (m[v].style.width =
            w.sWidthOrig !== null && w.sWidthOrig !== ''
              ? K(w.sWidthOrig)
              : ''),
          w.sWidthOrig &&
            h &&
            l(m[v]).append(
              l('<div/>').css({
                width: w.sWidthOrig,
                margin: 0,
                padding: 0,
                border: 0,
                height: 1,
              }),
            )
      if (a.aoData.length)
        for (v = 0; v < k.length; v++)
          (t = k[v]),
            (w = c[t]),
            l(dc(a, t)).clone(!1).append(w.sContentPadding).appendTo(r)
      l('[name]', g).removeAttr('name')
      w = l('<div/>')
        .css(
          h || e
            ? {
                position: 'absolute',
                top: 0,
                left: 0,
                height: 1,
                right: 0,
                overflow: 'hidden',
              }
            : {},
        )
        .append(g)
        .appendTo(p)
      h && f
        ? g.width(f)
        : h
        ? (g.css('width', 'auto'),
          g.removeAttr('width'),
          g.width() < p.clientWidth && n && g.width(p.clientWidth))
        : e
        ? g.width(p.clientWidth)
        : n && g.width(n)
      for (v = e = 0; v < k.length; v++)
        (p = l(m[v])),
          (f = p.outerWidth() - p.width()),
          (p = x.bBounding
            ? Math.ceil(m[v].getBoundingClientRect().width)
            : p.outerWidth()),
          (e += p),
          (c[k[v]].sWidth = K(p - f))
      b.style.width = K(e)
      w.remove()
    }
    n && (b.style.width = K(n))
    ;(!n && !h) ||
      a._reszEvt ||
      ((b = function () {
        l(y).on(
          `resize.DT-${a.sInstance}`,
          mb(function () {
            sa(a)
          }),
        )
      }),
      d ? setTimeout(b, 1e3) : b(),
      (a._reszEvt = !0))
  }
  function cc(a, b) {
    if (!a) return 0
    a = l('<div/>')
      .css('width', K(a))
      .appendTo(b || A.body)
    b = a[0].offsetWidth
    a.remove()
    return b
  }
  function dc(a, b) {
    const c = ec(a, b)
    if (c < 0) return null
    const d = a.aoData[c]
    return d.nTr ? d.anCells[b] : l('<td/>').html(T(a, c, b, 'display'))[0]
  }
  function ec(a, b) {
    for (var c, d = -1, e = -1, h = 0, f = a.aoData.length; h < f; h++)
      (c = `${T(a, h, b, 'display')}`),
        (c = c.replace(Cc, '')),
        (c = c.replace(/&nbsp;/g, ' ')),
        c.length > d && ((d = c.length), (e = h))
    return e
  }
  function K(a) {
    return a === null
      ? '0px'
      : typeof a === 'number'
      ? a < 0
        ? '0px'
        : `${a}px`
      : a.match(/\d$/)
      ? `${a}px`
      : a
  }
  function oa(a) {
    const b = []
    const c = a.aoColumns
    let d = a.aaSortingFixed
    let e = l.isPlainObject(d)
    const h = []
    let f = function (n) {
      n.length && !Array.isArray(n[0]) ? h.push(n) : l.merge(h, n)
    }
    Array.isArray(d) && f(d)
    e && d.pre && f(d.pre)
    f(a.aaSorting)
    e && d.post && f(d.post)
    for (a = 0; a < h.length; a++) {
      const g = h[a][0]
      f = c[g].aDataSort
      d = 0
      for (e = f.length; d < e; d++) {
        const k = f[d]
        const m = c[k].sType || 'string'
        h[a]._idx === q && (h[a]._idx = l.inArray(h[a][1], c[k].asSorting))
        b.push({
          src: g,
          col: k,
          dir: h[a][1],
          index: h[a]._idx,
          type: m,
          formatter: u.ext.type.order[`${m}-pre`],
        })
      }
    }
    return b
  }
  function Lb(a) {
    let b
    const c = []
    const d = u.ext.type.order
    const e = a.aoData
    let h = 0
    const f = a.aiDisplayMaster
    eb(a)
    const g = oa(a)
    let k = 0
    for (b = g.length; k < b; k++) {
      const m = g[k]
      m.formatter && h++
      fc(a, m.col)
    }
    if (Q(a) != 'ssp' && g.length !== 0) {
      k = 0
      for (b = f.length; k < b; k++) c[f[k]] = k
      h === g.length
        ? f.sort(function (n, p) {
            let t
            const v = g.length
            const x = e[n]._aSortData
            const w = e[p]._aSortData
            for (t = 0; t < v; t++) {
              const r = g[t]
              var C = x[r.col]
              var G = w[r.col]
              C = C < G ? -1 : C > G ? 1 : 0
              if (C !== 0) return r.dir === 'asc' ? C : -C
            }
            C = c[n]
            G = c[p]
            return C < G ? -1 : C > G ? 1 : 0
          })
        : f.sort(function (n, p) {
            let t
            const v = g.length
            const x = e[n]._aSortData
            const w = e[p]._aSortData
            for (t = 0; t < v; t++) {
              let r = g[t]
              var C = x[r.col]
              var G = w[r.col]
              r = d[`${r.type}-${r.dir}`] || d[`string-${r.dir}`]
              C = r(C, G)
              if (C !== 0) return C
            }
            C = c[n]
            G = c[p]
            return C < G ? -1 : C > G ? 1 : 0
          })
    }
    a.bSorted = !0
  }
  function gc(a) {
    const b = a.aoColumns
    const c = oa(a)
    a = a.oLanguage.oAria
    for (let d = 0, e = b.length; d < e; d++) {
      let h = b[d]
      const f = h.asSorting
      let g = h.ariaTitle || h.sTitle.replace(/<.*?>/g, '')
      const k = h.nTh
      k.removeAttribute('aria-sort')
      h.bSortable &&
        (c.length > 0 && c[0].col == d
          ? (k.setAttribute(
              'aria-sort',
              c[0].dir == 'asc' ? 'ascending' : 'descending',
            ),
            (h = f[c[0].index + 1] || f[0]))
          : (h = f[0]),
        (g += h === 'asc' ? a.sSortAscending : a.sSortDescending))
      k.setAttribute('aria-label', g)
    }
  }
  function rb(a, b, c, d) {
    let e = a.aaSorting
    const h = a.aoColumns[b].asSorting
    const f = function (g, k) {
      let m = g._idx
      m === q && (m = l.inArray(g[1], h))
      return m + 1 < h.length ? m + 1 : k ? null : 0
    }
    typeof e[0] === 'number' && (e = a.aaSorting = [e])
    c && a.oFeatures.bSortMulti
      ? ((c = l.inArray(b, U(e, '0'))),
        c !== -1
          ? ((b = f(e[c], !0)),
            b === null && e.length === 1 && (b = 0),
            b === null ? e.splice(c, 1) : ((e[c][1] = h[b]), (e[c]._idx = b)))
          : (e.push([b, h[0], 0]), (e[e.length - 1]._idx = 0)))
      : e.length && e[0][0] == b
      ? ((b = f(e[0])), (e.length = 1), (e[0][1] = h[b]), (e[0]._idx = b))
      : ((e.length = 0), e.push([b, h[0]]), (e[0]._idx = 0))
    ka(a)
    typeof d === 'function' && d(a)
  }
  function kb(a, b, c, d) {
    const e = a.aoColumns[c]
    sb(b, {}, function (h) {
      !1 !== e.bSortable &&
        (a.oFeatures.bProcessing
          ? (V(a, !0),
            setTimeout(function () {
              rb(a, c, h.shiftKey, d)
              Q(a) !== 'ssp' && V(a, !1)
            }, 0))
          : rb(a, c, h.shiftKey, d))
    })
  }
  function Va(a) {
    const b = a.aLastSort
    const c = a.oClasses.sSortColumn
    const d = oa(a)
    let e = a.oFeatures
    let h
    if (e.bSort && e.bSortClasses) {
      e = 0
      for (h = b.length; e < h; e++) {
        var f = b[e].src
        l(U(a.aoData, 'anCells', f)).removeClass(c + (e < 2 ? e + 1 : 3))
      }
      e = 0
      for (h = d.length; e < h; e++)
        (f = d[e].src),
          l(U(a.aoData, 'anCells', f)).addClass(c + (e < 2 ? e + 1 : 3))
    }
    a.aLastSort = d
  }
  function fc(a, b) {
    let c = a.aoColumns[b]
    const d = u.ext.order[c.sSortDataType]
    let e
    d && (e = d.call(a.oInstance, a, b, ua(a, b)))
    for (
      var h, f = u.ext.type.order[`${c.sType}-pre`], g = 0, k = a.aoData.length;
      g < k;
      g++
    )
      if (
        ((c = a.aoData[g]),
        c._aSortData || (c._aSortData = []),
        !c._aSortData[b] || d)
      )
        (h = d ? e[g] : T(a, g, b, 'sort')), (c._aSortData[b] = f ? f(h) : h)
  }
  function Da(a) {
    if (!a._bLoadingState) {
      const b = {
        time: +new Date(),
        start: a._iDisplayStart,
        length: a._iDisplayLength,
        order: l.extend(!0, [], a.aaSorting),
        search: Zb(a.oPreviousSearch),
        columns: l.map(a.aoColumns, function (c, d) {
          return { visible: c.bVisible, search: Zb(a.aoPreSearchCols[d]) }
        }),
      }
      a.oSavedState = b
      F(a, 'aoStateSaveParams', 'stateSaveParams', [a, b])
      a.oFeatures.bStateSave &&
        !a.bDestroying &&
        a.fnStateSaveCallback.call(a.oInstance, a, b)
    }
  }
  function hc(a, b, c) {
    if (a.oFeatures.bStateSave)
      return (
        (b = a.fnStateLoadCallback.call(a.oInstance, a, function (d) {
          tb(a, d, c)
        })),
        b !== q && tb(a, b, c),
        !0
      )
    c()
  }
  function tb(a, b, c) {
    let d
    const e = a.aoColumns
    a._bLoadingState = !0
    const h = a._bInitComplete ? new u.Api(a) : null
    if (b && b.time) {
      let f = F(a, 'aoStateLoadParams', 'stateLoadParams', [a, b])
      if (l.inArray(!1, f) !== -1) a._bLoadingState = !1
      else if (
        ((f = a.iStateDuration), f > 0 && b.time < +new Date() - 1e3 * f)
      )
        a._bLoadingState = !1
      else if (b.columns && e.length !== b.columns.length) a._bLoadingState = !1
      else {
        a.oLoadedState = l.extend(!0, {}, b)
        b.length !== q &&
          (h ? h.page.len(b.length) : (a._iDisplayLength = b.length))
        b.start !== q &&
          (h === null
            ? ((a._iDisplayStart = b.start), (a.iInitDisplayStart = b.start))
            : Ta(a, b.start / a._iDisplayLength))
        b.order !== q &&
          ((a.aaSorting = []),
          l.each(b.order, function (k, m) {
            a.aaSorting.push(m[0] >= e.length ? [0, m[1]] : m)
          }))
        b.search !== q && l.extend(a.oPreviousSearch, $b(b.search))
        if (b.columns) {
          f = 0
          for (d = b.columns.length; f < d; f++) {
            const g = b.columns[f]
            g.visible !== q &&
              (h
                ? h.column(f).visible(g.visible, !1)
                : (e[f].bVisible = g.visible))
            g.search !== q && l.extend(a.aoPreSearchCols[f], $b(g.search))
          }
          h && h.columns.adjust()
        }
        a._bLoadingState = !1
        F(a, 'aoStateLoaded', 'stateLoaded', [a, b])
      }
    } else a._bLoadingState = !1
    c()
  }
  function Wa(a) {
    const b = u.settings
    a = l.inArray(a, U(b, 'nTable'))
    return a !== -1 ? b[a] : null
  }
  function ea(a, b, c, d) {
    c = `DataTables warning: ${a ? `table id=${a.sTableId} - ` : ''}${c}`
    d &&
      (c += `. For more information about this error, please see http://datatables.net/tn/${d}`)
    if (b) y.console && console.log && console.log(c)
    else if (
      ((b = u.ext),
      (b = b.sErrMode || b.errMode),
      a && F(a, null, 'error', [a, d, c]),
      b == 'alert')
    )
      alert(c)
    else {
      if (b == 'throw') throw Error(c)
      typeof b === 'function' && b(a, d, c)
    }
  }
  function Y(a, b, c, d) {
    Array.isArray(c)
      ? l.each(c, function (e, h) {
          Array.isArray(h) ? Y(a, b, h[0], h[1]) : Y(a, b, h)
        })
      : (d === q && (d = c), b[c] !== q && (a[d] = b[c]))
  }
  function ub(a, b, c) {
    let d
    for (d in b)
      if (b.hasOwnProperty(d)) {
        const e = b[d]
        l.isPlainObject(e)
          ? (l.isPlainObject(a[d]) || (a[d] = {}), l.extend(!0, a[d], e))
          : c && d !== 'data' && d !== 'aaData' && Array.isArray(e)
          ? (a[d] = e.slice())
          : (a[d] = e)
      }
    return a
  }
  function sb(a, b, c) {
    l(a)
      .on('click.DT', b, function (d) {
        l(a).trigger('blur')
        c(d)
      })
      .on('keypress.DT', b, function (d) {
        d.which === 13 && (d.preventDefault(), c(d))
      })
      .on('selectstart.DT', function () {
        return !1
      })
  }
  function R(a, b, c, d) {
    c && a[b].push({ fn: c, sName: d })
  }
  function F(a, b, c, d) {
    let e = []
    b &&
      (e = l.map(a[b].slice().reverse(), function (h, f) {
        return h.fn.apply(a.oInstance, d)
      }))
    c !== null &&
      ((b = l.Event(`${c}.dt`)), l(a.nTable).trigger(b, d), e.push(b.result))
    return e
  }
  function qb(a) {
    let b = a._iDisplayStart
    const c = a.fnDisplayEnd()
    const d = a._iDisplayLength
    b >= c && (b = c - d)
    b -= b % d
    if (d === -1 || b < 0) b = 0
    a._iDisplayStart = b
  }
  function lb(a, b) {
    a = a.renderer
    const c = u.ext.renderer[b]
    return l.isPlainObject(a) && a[b]
      ? c[a[b]] || c._
      : typeof a === 'string'
      ? c[a] || c._
      : c._
  }
  function Q(a) {
    return a.oFeatures.bServerSide
      ? 'ssp'
      : a.ajax || a.sAjaxSource
      ? 'ajax'
      : 'dom'
  }
  function Ea(a, b) {
    const c = ic.numbers_length
    const d = Math.floor(c / 2)
    b <= c
      ? (a = pa(0, b))
      : a <= d
      ? ((a = pa(0, c - 2)), a.push('ellipsis'), a.push(b - 1))
      : (a >= b - 1 - d
          ? (a = pa(b - (c - 2), b))
          : ((a = pa(a - d + 2, a + d - 1)), a.push('ellipsis'), a.push(b - 1)),
        a.splice(0, 0, 'ellipsis'),
        a.splice(0, 0, 0))
    a.DT_el = 'span'
    return a
  }
  function bb(a) {
    l.each(
      {
        'num': function (b) {
          return Xa(b, a)
        },
        'num-fmt': function (b) {
          return Xa(b, a, vb)
        },
        'html-num': function (b) {
          return Xa(b, a, Ya)
        },
        'html-num-fmt': function (b) {
          return Xa(b, a, Ya, vb)
        },
      },
      function (b, c) {
        M.type.order[`${b + a}-pre`] = c
        b.match(/^html\-/) && (M.type.search[b + a] = M.type.search.html)
      },
    )
  }
  function jc(a, b, c, d, e) {
    return y.moment ? a[b](e) : y.luxon ? a[c](e) : d ? a[d](e) : a
  }
  function Za(a, b, c) {
    if (y.moment) {
      var d = y.moment.utc(a, b, c, !0)
      if (!d.isValid()) return null
    } else if (y.luxon) {
      d = b ? y.luxon.DateTime.fromFormat(a, b) : y.luxon.DateTime.fromISO(a)
      if (!d.isValid) return null
      d.setLocale(c)
    } else
      b
        ? (kc ||
            alert(
              'DataTables warning: Formatted date without Moment.js or Luxon - https://datatables.net/tn/17',
            ),
          (kc = !0))
        : (d = new Date(a))
    return d
  }
  function wb(a) {
    return function (b, c, d, e) {
      arguments.length === 0
        ? ((d = 'en'), (b = c = null))
        : arguments.length === 1
        ? ((d = 'en'), (c = b), (b = null))
        : arguments.length === 2 && ((d = c), (c = b), (b = null))
      const h = `datetime-${c}`
      u.ext.type.order[h] ||
        (u.ext.type.detect.unshift(function (f) {
          return f === h ? h : !1
        }),
        (u.ext.type.order[`${h}-asc`] = function (f, g) {
          f = f.valueOf()
          g = g.valueOf()
          return f === g ? 0 : f < g ? -1 : 1
        }),
        (u.ext.type.order[`${h}-desc`] = function (f, g) {
          f = f.valueOf()
          g = g.valueOf()
          return f === g ? 0 : f > g ? -1 : 1
        }))
      return function (f, g) {
        if (f === null || f === q)
          e === '--now'
            ? ((f = new Date()),
              (f = new Date(
                Date.UTC(
                  f.getFullYear(),
                  f.getMonth(),
                  f.getDate(),
                  f.getHours(),
                  f.getMinutes(),
                  f.getSeconds(),
                ),
              )))
            : (f = '')
        if (g === 'type') return h
        if (f === '')
          return g !== 'sort' ? '' : Za('0000-01-01 00:00:00', null, d)
        if (
          c !== null &&
          b === c &&
          g !== 'sort' &&
          g !== 'type' &&
          !(f instanceof Date)
        )
          return f
        const k = Za(f, b, d)
        if (k === null) return f
        if (g === 'sort') return k
        f =
          c === null
            ? jc(k, 'toDate', 'toJSDate', '')[a]()
            : jc(k, 'format', 'toFormat', 'toISOString', c)
        return g === 'display' ? $a(f) : f
      }
    }
  }
  function lc(a) {
    return function () {
      const b = [Wa(this[u.ext.iApiIndex])].concat(
        Array.prototype.slice.call(arguments),
      )
      return u.ext.internal[a].apply(this, b)
    }
  }
  var u = function (a, b) {
    if (this instanceof u) return l(a).DataTable(b)
    b = a
    this.$ = function (f, g) {
      return this.api(!0).$(f, g)
    }
    this._ = function (f, g) {
      return this.api(!0).rows(f, g).data()
    }
    this.api = function (f) {
      return f ? new B(Wa(this[M.iApiIndex])) : new B(this)
    }
    this.fnAddData = function (f, g) {
      const k = this.api(!0)
      f =
        Array.isArray(f) && (Array.isArray(f[0]) || l.isPlainObject(f[0]))
          ? k.rows.add(f)
          : k.row.add(f)
      ;(g === q || g) && k.draw()
      return f.flatten().toArray()
    }
    this.fnAdjustColumnSizing = function (f) {
      const g = this.api(!0).columns.adjust()
      const k = g.settings()[0]
      const m = k.oScroll
      f === q || f ? g.draw(!1) : (m.sX !== '' || m.sY !== '') && Ja(k)
    }
    this.fnClearTable = function (f) {
      const g = this.api(!0).clear()
      ;(f === q || f) && g.draw()
    }
    this.fnClose = function (f) {
      this.api(!0).row(f).child.hide()
    }
    this.fnDeleteRow = function (f, g, k) {
      const m = this.api(!0)
      f = m.rows(f)
      const n = f.settings()[0]
      const p = n.aoData[f[0][0]]
      f.remove()
      g && g.call(this, n, p)
      ;(k === q || k) && m.draw()
      return p
    }
    this.fnDestroy = function (f) {
      this.api(!0).destroy(f)
    }
    this.fnDraw = function (f) {
      this.api(!0).draw(f)
    }
    this.fnFilter = function (f, g, k, m, n, p) {
      n = this.api(!0)
      g === null || g === q
        ? n.search(f, k, m, p)
        : n.column(g).search(f, k, m, p)
      n.draw()
    }
    this.fnGetData = function (f, g) {
      const k = this.api(!0)
      if (f !== q) {
        const m = f.nodeName ? f.nodeName.toLowerCase() : ''
        return g !== q || m == 'td' || m == 'th'
          ? k.cell(f, g).data()
          : k.row(f).data() || null
      }
      return k.data().toArray()
    }
    this.fnGetNodes = function (f) {
      const g = this.api(!0)
      return f !== q ? g.row(f).node() : g.rows().nodes().flatten().toArray()
    }
    this.fnGetPosition = function (f) {
      const g = this.api(!0)
      const k = f.nodeName.toUpperCase()
      return k == 'TR'
        ? g.row(f).index()
        : k == 'TD' || k == 'TH'
        ? ((f = g.cell(f).index()), [f.row, f.columnVisible, f.column])
        : null
    }
    this.fnIsOpen = function (f) {
      return this.api(!0).row(f).child.isShown()
    }
    this.fnOpen = function (f, g, k) {
      return this.api(!0).row(f).child(g, k).show().child()[0]
    }
    this.fnPageChange = function (f, g) {
      f = this.api(!0).page(f)
      ;(g === q || g) && f.draw(!1)
    }
    this.fnSetColumnVis = function (f, g, k) {
      f = this.api(!0).column(f).visible(g)
      ;(k === q || k) && f.columns.adjust().draw()
    }
    this.fnSettings = function () {
      return Wa(this[M.iApiIndex])
    }
    this.fnSort = function (f) {
      this.api(!0).order(f).draw()
    }
    this.fnSortListener = function (f, g, k) {
      this.api(!0).order.listener(f, g, k)
    }
    this.fnUpdate = function (f, g, k, m, n) {
      const p = this.api(!0)
      k === q || k === null ? p.row(g).data(f) : p.cell(g, k).data(f)
      ;(n === q || n) && p.columns.adjust()
      ;(m === q || m) && p.draw()
      return 0
    }
    this.fnVersionCheck = M.fnVersionCheck
    let c = this
    const d = b === q
    const e = this.length
    d && (b = {})
    this.oApi = this.internal = M.internal
    for (const h in u.ext.internal) h && (this[h] = lc(h))
    this.each(function () {
      let f = {}
      let g = e > 1 ? ub(f, b, !0) : b
      let k = 0
      let m
      f = this.getAttribute('id')
      let n = !1
      const p = u.defaults
      const t = l(this)
      if (this.nodeName.toLowerCase() != 'table')
        ea(null, 0, `Non-table node initialisation (${this.nodeName})`, 2)
      else {
        Db(p)
        Eb(p.column)
        P(p, p, !0)
        P(p.column, p.column, !0)
        P(p, l.extend(g, t.data()), !0)
        let v = u.settings
        k = 0
        for (m = v.length; k < m; k++) {
          const x = v[k]
          if (
            x.nTable == this ||
            (x.nTHead && x.nTHead.parentNode == this) ||
            (x.nTFoot && x.nTFoot.parentNode == this)
          ) {
            const w = g.bRetrieve !== q ? g.bRetrieve : p.bRetrieve
            if (d || w) return x.oInstance
            if (g.bDestroy !== q ? g.bDestroy : p.bDestroy) {
              x.oInstance.fnDestroy()
              break
            } else {
              ea(x, 0, 'Cannot reinitialise DataTable', 3)
              return
            }
          }
          if (x.sTableId == this.id) {
            v.splice(k, 1)
            break
          }
        }
        if (f === null || f === '')
          this.id = f = `DataTables_Table_${u.ext._unique++}`
        const r = l.extend(!0, {}, u.models.oSettings, {
          sDestroyWidth: t[0].style.width,
          sInstance: f,
          sTableId: f,
        })
        r.nTable = this
        r.oApi = c.internal
        r.oInit = g
        v.push(r)
        r.oInstance = c.length === 1 ? c : t.dataTable()
        Db(g)
        la(g.oLanguage)
        g.aLengthMenu &&
          !g.iDisplayLength &&
          (g.iDisplayLength = Array.isArray(g.aLengthMenu[0])
            ? g.aLengthMenu[0][0]
            : g.aLengthMenu[0])
        g = ub(l.extend(!0, {}, p), g)
        Y(
          r.oFeatures,
          g,
          'bPaginate bLengthChange bFilter bSort bSortMulti bInfo bProcessing bAutoWidth bSortClasses bServerSide bDeferRender'.split(
            ' ',
          ),
        )
        Y(r, g, [
          'asStripeClasses',
          'ajax',
          'fnServerData',
          'fnFormatNumber',
          'sServerMethod',
          'aaSorting',
          'aaSortingFixed',
          'aLengthMenu',
          'sPaginationType',
          'sAjaxSource',
          'sAjaxDataProp',
          'iStateDuration',
          'sDom',
          'bSortCellsTop',
          'iTabIndex',
          'fnStateLoadCallback',
          'fnStateSaveCallback',
          'renderer',
          'searchDelay',
          'rowId',
          ['iCookieDuration', 'iStateDuration'],
          ['oSearch', 'oPreviousSearch'],
          ['aoSearchCols', 'aoPreSearchCols'],
          ['iDisplayLength', '_iDisplayLength'],
        ])
        Y(r.oScroll, g, [
          ['sScrollX', 'sX'],
          ['sScrollXInner', 'sXInner'],
          ['sScrollY', 'sY'],
          ['bScrollCollapse', 'bCollapse'],
        ])
        Y(r.oLanguage, g, 'fnInfoCallback')
        R(r, 'aoDrawCallback', g.fnDrawCallback, 'user')
        R(r, 'aoServerParams', g.fnServerParams, 'user')
        R(r, 'aoStateSaveParams', g.fnStateSaveParams, 'user')
        R(r, 'aoStateLoadParams', g.fnStateLoadParams, 'user')
        R(r, 'aoStateLoaded', g.fnStateLoaded, 'user')
        R(r, 'aoRowCallback', g.fnRowCallback, 'user')
        R(r, 'aoRowCreatedCallback', g.fnCreatedRow, 'user')
        R(r, 'aoHeaderCallback', g.fnHeaderCallback, 'user')
        R(r, 'aoFooterCallback', g.fnFooterCallback, 'user')
        R(r, 'aoInitComplete', g.fnInitComplete, 'user')
        R(r, 'aoPreDrawCallback', g.fnPreDrawCallback, 'user')
        r.rowIdFn = ma(g.rowId)
        Fb(r)
        const C = r.oClasses
        l.extend(C, u.ext.classes, g.oClasses)
        t.addClass(C.sTable)
        r.iInitDisplayStart === q &&
          ((r.iInitDisplayStart = g.iDisplayStart),
          (r._iDisplayStart = g.iDisplayStart))
        g.iDeferLoading !== null &&
          ((r.bDeferLoading = !0),
          (f = Array.isArray(g.iDeferLoading)),
          (r._iRecordsDisplay = f ? g.iDeferLoading[0] : g.iDeferLoading),
          (r._iRecordsTotal = f ? g.iDeferLoading[1] : g.iDeferLoading))
        const G = r.oLanguage
        l.extend(!0, G, g.oLanguage)
        G.sUrl
          ? (l.ajax({
              dataType: 'json',
              url: G.sUrl,
              success(I) {
                P(p.oLanguage, I)
                la(I)
                l.extend(!0, G, I, r.oInit.oLanguage)
                F(r, null, 'i18n', [r])
                Aa(r)
              },
              error() {
                Aa(r)
              },
            }),
            (n = !0))
          : F(r, null, 'i18n', [r])
        g.asStripeClasses === null &&
          (r.asStripeClasses = [C.sStripeOdd, C.sStripeEven])
        f = r.asStripeClasses
        const ba = t.children('tbody').find('tr').eq(0)
        l.inArray(
          !0,
          l.map(f, function (I, H) {
            return ba.hasClass(I)
          }),
        ) !== -1 &&
          (l('tbody tr', this).removeClass(f.join(' ')),
          (r.asDestroyStripes = f.slice()))
        f = []
        v = this.getElementsByTagName('thead')
        v.length !== 0 && (wa(r.aoHeader, v[0]), (f = Pa(r)))
        if (g.aoColumns === null)
          for (v = [], k = 0, m = f.length; k < m; k++) v.push(null)
        else v = g.aoColumns
        k = 0
        for (m = v.length; k < m; k++) cb(r, f ? f[k] : null)
        Hb(r, g.aoColumnDefs, v, function (I, H) {
          Ia(r, I, H)
        })
        if (ba.length) {
          const L = function (I, H) {
            return I.getAttribute(`data-${H}`) !== null ? H : null
          }
          l(ba[0])
            .children('th, td')
            .each(function (I, H) {
              const fa = r.aoColumns[I]
              if (fa.mData === I) {
                const Z = L(H, 'sort') || L(H, 'order')
                H = L(H, 'filter') || L(H, 'search')
                if (Z !== null || H !== null)
                  (fa.mData = {
                    _: `${I}.display`,
                    sort: Z !== null ? `${I}.@data-${Z}` : q,
                    type: Z !== null ? `${I}.@data-${Z}` : q,
                    filter: H !== null ? `${I}.@data-${H}` : q,
                  }),
                    Ia(r, I)
              }
            })
        }
        const O = r.oFeatures
        f = function () {
          if (g.aaSorting === q) {
            var I = r.aaSorting
            k = 0
            for (m = I.length; k < m; k++) I[k][1] = r.aoColumns[k].asSorting[0]
          }
          Va(r)
          O.bSort &&
            R(r, 'aoDrawCallback', function () {
              if (r.bSorted) {
                const Z = oa(r)
                const Ba = {}
                l.each(Z, function (X, ca) {
                  Ba[ca.src] = ca.dir
                })
                F(r, null, 'order', [r, Z, Ba])
                gc(r)
              }
            })
          R(
            r,
            'aoDrawCallback',
            function () {
              ;(r.bSorted || Q(r) === 'ssp' || O.bDeferRender) && Va(r)
            },
            'sc',
          )
          I = t.children('caption').each(function () {
            this._captionSide = l(this).css('caption-side')
          })
          let H = t.children('thead')
          H.length === 0 && (H = l('<thead/>').appendTo(t))
          r.nTHead = H[0]
          let fa = t.children('tbody')
          fa.length === 0 && (fa = l('<tbody/>').insertAfter(H))
          r.nTBody = fa[0]
          H = t.children('tfoot')
          H.length === 0 &&
            I.length > 0 &&
            (r.oScroll.sX !== '' || r.oScroll.sY !== '') &&
            (H = l('<tfoot/>').appendTo(t))
          H.length === 0 || H.children().length === 0
            ? t.addClass(C.sNoFooter)
            : H.length > 0 && ((r.nTFoot = H[0]), wa(r.aoFooter, r.nTFoot))
          if (g.aaData) for (k = 0; k < g.aaData.length; k++) ia(r, g.aaData[k])
          else
            (r.bDeferLoading || Q(r) == 'dom') &&
              La(r, l(r.nTBody).children('tr'))
          r.aiDisplay = r.aiDisplayMaster.slice()
          r.bInitialised = !0
          !1 === n && Aa(r)
        }
        R(r, 'aoDrawCallback', Da, 'state_save')
        g.bStateSave ? ((O.bStateSave = !0), hc(r, g, f)) : f()
      }
    })
    c = null
    return this
  }
  let M
  let z
  let J
  const xb = {}
  const mc = /[\r\n\u2028]/g
  var Ya = /<.*?>/g
  const Dc =
    /^\d{2,4}[\.\/\-]\d{1,2}[\.\/\-]\d{1,2}([T ]{1}\d{1,2}[:\.]\d{2}([\.:]\d{2})?)?$/
  const Ec = /(\/|\.|\*|\+|\?|\||\(|\)|\[|\]|\{|\}|\\|\$|\^|\-)/g
  var vb = /['\u00A0,$£€¥%\u2009\u202F\u20BD\u20a9\u20BArfkɃΞ]/gi
  var aa = function (a) {
    return a && !0 !== a && a !== '-' ? !1 : !0
  }
  const nc = function (a) {
    const b = parseInt(a, 10)
    return !isNaN(b) && isFinite(a) ? b : null
  }
  const oc = function (a, b) {
    xb[b] || (xb[b] = new RegExp(ob(b), 'g'))
    return typeof a === 'string' && b !== '.'
      ? a.replace(/\./g, '').replace(xb[b], '.')
      : a
  }
  const yb = function (a, b, c) {
    const d = typeof a === 'string'
    if (aa(a)) return !0
    b && d && (a = oc(a, b))
    c && d && (a = a.replace(vb, ''))
    return !isNaN(parseFloat(a)) && isFinite(a)
  }
  const pc = function (a, b, c) {
    return aa(a)
      ? !0
      : aa(a) || typeof a === 'string'
      ? yb(a.replace(Ya, ''), b, c)
        ? !0
        : null
      : null
  }
  var U = function (a, b, c) {
    const d = []
    let e = 0
    const h = a.length
    if (c !== q) for (; e < h; e++) a[e] && a[e][b] && d.push(a[e][b][c])
    else for (; e < h; e++) a[e] && d.push(a[e][b])
    return d
  }
  const Fa = function (a, b, c, d) {
    const e = []
    let h = 0
    const f = b.length
    if (d !== q) for (; h < f; h++) a[b[h]][c] && e.push(a[b[h]][c][d])
    else for (; h < f; h++) e.push(a[b[h]][c])
    return e
  }
  var pa = function (a, b) {
    const c = []
    if (b === q) {
      b = 0
      var d = a
    } else (d = b), (b = a)
    for (a = b; a < d; a++) c.push(a)
    return c
  }
  const qc = function (a) {
    for (var b = [], c = 0, d = a.length; c < d; c++) a[c] && b.push(a[c])
    return b
  }
  var Oa = function (a) {
    a: {
      if (!(a.length < 2)) {
        var b = a.slice().sort()
        for (var c = b[0], d = 1, e = b.length; d < e; d++) {
          if (b[d] === c) {
            b = !1
            break a
          }
          c = b[d]
        }
      }
      b = !0
    }
    if (b) return a.slice()
    b = []
    e = a.length
    let h
    let f = 0
    d = 0
    a: for (; d < e; d++) {
      c = a[d]
      for (h = 0; h < f; h++) if (b[h] === c) continue a
      b.push(c)
      f++
    }
    return b
  }
  var rc = function (a, b) {
    if (Array.isArray(b)) for (let c = 0; c < b.length; c++) rc(a, b[c])
    else a.push(b)
    return a
  }
  const sc = function (a, b) {
    b === q && (b = 0)
    return this.indexOf(a, b) !== -1
  }
  Array.isArray ||
    (Array.isArray = function (a) {
      return Object.prototype.toString.call(a) === '[object Array]'
    })
  Array.prototype.includes || (Array.prototype.includes = sc)
  String.prototype.trim ||
    (String.prototype.trim = function () {
      return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '')
    })
  String.prototype.includes || (String.prototype.includes = sc)
  u.util = {
    throttle(a, b) {
      const c = b !== q ? b : 200
      let d
      let e
      return function () {
        const h = this
        const f = +new Date()
        const g = arguments
        d && f < d + c
          ? (clearTimeout(e),
            (e = setTimeout(function () {
              d = q
              a.apply(h, g)
            }, c)))
          : ((d = f), a.apply(h, g))
      }
    },
    escapeRegex(a) {
      return a.replace(Ec, '\\$1')
    },
    set(a) {
      if (l.isPlainObject(a)) return u.util.set(a._)
      if (a === null) return function () {}
      if (typeof a === 'function')
        return function (c, d, e) {
          a(c, 'set', d, e)
        }
      if (
        typeof a !== 'string' ||
        (a.indexOf('.') === -1 &&
          a.indexOf('[') === -1 &&
          a.indexOf('(') === -1)
      )
        return function (c, d) {
          c[a] = d
        }
      var b = function (c, d, e) {
        e = hb(e)
        let h = e[e.length - 1]
        for (var f, g, k = 0, m = e.length - 1; k < m; k++) {
          if (e[k] === '__proto__' || e[k] === 'constructor')
            throw Error('Cannot set prototype values')
          f = e[k].match(Ga)
          g = e[k].match(qa)
          if (f) {
            e[k] = e[k].replace(Ga, '')
            c[e[k]] = []
            h = e.slice()
            h.splice(0, k + 1)
            f = h.join('.')
            if (Array.isArray(d))
              for (g = 0, m = d.length; g < m; g++)
                (h = {}), b(h, d[g], f), c[e[k]].push(h)
            else c[e[k]] = d
            return
          }
          g && ((e[k] = e[k].replace(qa, '')), (c = c[e[k]](d)))
          if (c[e[k]] === null || c[e[k]] === q) c[e[k]] = {}
          c = c[e[k]]
        }
        if (h.match(qa)) c[h.replace(qa, '')](d)
        else c[h.replace(Ga, '')] = d
      }
      return function (c, d) {
        return b(c, d, a)
      }
    },
    get(a) {
      if (l.isPlainObject(a)) {
        const b = {}
        l.each(a, function (d, e) {
          e && (b[d] = u.util.get(e))
        })
        return function (d, e, h, f) {
          const g = b[e] || b._
          return g !== q ? g(d, e, h, f) : d
        }
      }
      if (a === null)
        return function (d) {
          return d
        }
      if (typeof a === 'function')
        return function (d, e, h, f) {
          return a(d, e, h, f)
        }
      if (
        typeof a !== 'string' ||
        (a.indexOf('.') === -1 &&
          a.indexOf('[') === -1 &&
          a.indexOf('(') === -1)
      )
        return function (d, e) {
          return d[a]
        }
      var c = function (d, e, h) {
        if (h !== '') {
          let f = hb(h)
          for (let g = 0, k = f.length; g < k; g++) {
            h = f[g].match(Ga)
            let m = f[g].match(qa)
            if (h) {
              f[g] = f[g].replace(Ga, '')
              f[g] !== '' && (d = d[f[g]])
              m = []
              f.splice(0, g + 1)
              f = f.join('.')
              if (Array.isArray(d))
                for (g = 0, k = d.length; g < k; g++) m.push(c(d[g], e, f))
              d = h[0].substring(1, h[0].length - 1)
              d = d === '' ? m : m.join(d)
              break
            } else if (m) {
              f[g] = f[g].replace(qa, '')
              d = d[f[g]]()
              continue
            }
            if (d === null || d[f[g]] === q) return q
            d = d[f[g]]
          }
        }
        return d
      }
      return function (d, e) {
        return c(d, e, a)
      }
    },
  }
  var S = function (a, b, c) {
    a[b] !== q && (a[c] = a[b])
  }
  var Ga = /\[.*?\]$/
  var qa = /\(\)$/
  var ma = u.util.get
  var ha = u.util.set
  var ob = u.util.escapeRegex
  var Sa = l('<div>')[0]
  var Bc = Sa.textContent !== q
  var Cc = /<.*?>/g
  var mb = u.util.throttle
  const tc = []
  const N = Array.prototype
  const Fc = function (a) {
    let b
    const c = u.settings
    const d = l.map(c, function (h, f) {
      return h.nTable
    })
    if (a) {
      if (a.nTable && a.oApi) return [a]
      if (a.nodeName && a.nodeName.toLowerCase() === 'table') {
        var e = l.inArray(a, d)
        return e !== -1 ? [c[e]] : null
      }
      if (a && typeof a.settings === 'function') return a.settings().toArray()
      typeof a === 'string' ? (b = l(a)) : a instanceof l && (b = a)
    } else return []
    if (b)
      return b
        .map(function (h) {
          e = l.inArray(this, d)
          return e !== -1 ? c[e] : null
        })
        .toArray()
  }
  var B = function (a, b) {
    if (!(this instanceof B)) return new B(a, b)
    const c = []
    const d = function (f) {
      ;(f = Fc(f)) && c.push.apply(c, f)
    }
    if (Array.isArray(a)) for (let e = 0, h = a.length; e < h; e++) d(a[e])
    else d(a)
    this.context = Oa(c)
    b && l.merge(this, b)
    this.selector = { rows: null, cols: null, opts: null }
    B.extend(this, this, tc)
  }
  u.Api = B
  l.extend(B.prototype, {
    any() {
      return this.count() !== 0
    },
    concat: N.concat,
    context: [],
    count() {
      return this.flatten().length
    },
    each(a) {
      for (let b = 0, c = this.length; b < c; b++)
        a.call(this, this[b], b, this)
      return this
    },
    eq(a) {
      const b = this.context
      return b.length > a ? new B(b[a], this[a]) : null
    },
    filter(a) {
      let b = []
      if (N.filter) b = N.filter.call(this, a, this)
      else
        for (let c = 0, d = this.length; c < d; c++)
          a.call(this, this[c], c, this) && b.push(this[c])
      return new B(this.context, b)
    },
    flatten() {
      const a = []
      return new B(this.context, a.concat.apply(a, this.toArray()))
    },
    join: N.join,
    indexOf:
      N.indexOf ||
      function (a, b) {
        b = b || 0
        for (let c = this.length; b < c; b++) if (this[b] === a) return b
        return -1
      },
    iterator(a, b, c, d) {
      const e = []
      let h
      let f
      const g = this.context
      let k
      const m = this.selector
      typeof a === 'string' && ((d = c), (c = b), (b = a), (a = !1))
      let n = 0
      for (h = g.length; n < h; n++) {
        const p = new B(g[n])
        if (b === 'table') {
          var t = c.call(p, g[n], n)
          t !== q && e.push(t)
        } else if (b === 'columns' || b === 'rows')
          (t = c.call(p, g[n], this[n], n)), t !== q && e.push(t)
        else if (
          b === 'column' ||
          b === 'column-rows' ||
          b === 'row' ||
          b === 'cell'
        ) {
          const v = this[n]
          b === 'column-rows' && (k = ab(g[n], m.opts))
          let x = 0
          for (f = v.length; x < f; x++)
            (t = v[x]),
              (t =
                b === 'cell'
                  ? c.call(p, g[n], t.row, t.column, n, x)
                  : c.call(p, g[n], t, n, x, k)),
              t !== q && e.push(t)
        }
      }
      return e.length || d
        ? ((a = new B(g, a ? e.concat.apply([], e) : e)),
          (b = a.selector),
          (b.rows = m.rows),
          (b.cols = m.cols),
          (b.opts = m.opts),
          a)
        : this
    },
    lastIndexOf:
      N.lastIndexOf ||
      function (a, b) {
        return this.indexOf.apply(this.toArray.reverse(), arguments)
      },
    length: 0,
    map(a) {
      let b = []
      if (N.map) b = N.map.call(this, a, this)
      else
        for (let c = 0, d = this.length; c < d; c++)
          b.push(a.call(this, this[c], c))
      return new B(this.context, b)
    },
    pluck(a) {
      const b = u.util.get(a)
      return this.map(function (c) {
        return b(c)
      })
    },
    pop: N.pop,
    push: N.push,
    reduce:
      N.reduce ||
      function (a, b) {
        return Gb(this, a, b, 0, this.length, 1)
      },
    reduceRight:
      N.reduceRight ||
      function (a, b) {
        return Gb(this, a, b, this.length - 1, -1, -1)
      },
    reverse: N.reverse,
    selector: null,
    shift: N.shift,
    slice() {
      return new B(this.context, this)
    },
    sort: N.sort,
    splice: N.splice,
    toArray() {
      return N.slice.call(this)
    },
    to$() {
      return l(this)
    },
    toJQuery() {
      return l(this)
    },
    unique() {
      return new B(this.context, Oa(this))
    },
    unshift: N.unshift,
  })
  B.extend = function (a, b, c) {
    if (c.length && b && (b instanceof B || b.__dt_wrapper)) {
      let d
      const e = function (g, k, m) {
        return function () {
          const n = k.apply(g, arguments)
          B.extend(n, n, m.methodExt)
          return n
        }
      }
      let h = 0
      for (d = c.length; h < d; h++) {
        const f = c[h]
        b[f.name] =
          f.type === 'function'
            ? e(a, f.val, f)
            : f.type === 'object'
            ? {}
            : f.val
        b[f.name].__dt_wrapper = !0
        B.extend(a, b[f.name], f.propExt)
      }
    }
  }
  B.register = z = function (a, b) {
    if (Array.isArray(a))
      for (var c = 0, d = a.length; c < d; c++) B.register(a[c], b)
    else {
      d = a.split('.')
      let e = tc
      let h
      a = 0
      for (c = d.length; a < c; a++) {
        const f = (h = d[a].indexOf('()') !== -1)
          ? d[a].replace('()', '')
          : d[a]
        a: {
          var g = 0
          for (let k = e.length; g < k; g++)
            if (e[g].name === f) {
              g = e[g]
              break a
            }
          g = null
        }
        g ||
          ((g = {
            name: f,
            val: {},
            methodExt: [],
            propExt: [],
            type: 'object',
          }),
          e.push(g))
        a === c - 1
          ? ((g.val = b),
            (g.type =
              typeof b === 'function'
                ? 'function'
                : l.isPlainObject(b)
                ? 'object'
                : 'other'))
          : (e = h ? g.methodExt : g.propExt)
      }
    }
  }
  B.registerPlural = J = function (a, b, c) {
    B.register(a, c)
    B.register(b, function () {
      const d = c.apply(this, arguments)
      return d === this
        ? this
        : d instanceof B
        ? d.length
          ? Array.isArray(d[0])
            ? new B(d.context, d[0])
            : d[0]
          : q
        : d
    })
  }
  var uc = function (a, b) {
    if (Array.isArray(a))
      return l.map(a, function (d) {
        return uc(d, b)
      })
    if (typeof a === 'number') return [b[a]]
    const c = l.map(b, function (d, e) {
      return d.nTable
    })
    return l(c)
      .filter(a)
      .map(function (d) {
        d = l.inArray(this, c)
        return b[d]
      })
      .toArray()
  }
  z('tables()', function (a) {
    return a !== q && a !== null ? new B(uc(a, this.context)) : this
  })
  z('table()', function (a) {
    a = this.tables(a)
    const b = a.context
    return b.length ? new B(b[0]) : a
  })
  J('tables().nodes()', 'table().node()', function () {
    return this.iterator(
      'table',
      function (a) {
        return a.nTable
      },
      1,
    )
  })
  J('tables().body()', 'table().body()', function () {
    return this.iterator(
      'table',
      function (a) {
        return a.nTBody
      },
      1,
    )
  })
  J('tables().header()', 'table().header()', function () {
    return this.iterator(
      'table',
      function (a) {
        return a.nTHead
      },
      1,
    )
  })
  J('tables().footer()', 'table().footer()', function () {
    return this.iterator(
      'table',
      function (a) {
        return a.nTFoot
      },
      1,
    )
  })
  J('tables().containers()', 'table().container()', function () {
    return this.iterator(
      'table',
      function (a) {
        return a.nTableWrapper
      },
      1,
    )
  })
  z('draw()', function (a) {
    return this.iterator('table', function (b) {
      a === 'page'
        ? ja(b)
        : (typeof a === 'string' && (a = a === 'full-hold' ? !1 : !0),
          ka(b, !1 === a))
    })
  })
  z('page()', function (a) {
    return a === q
      ? this.page.info().page
      : this.iterator('table', function (b) {
          Ta(b, a)
        })
  })
  z('page.info()', function (a) {
    if (this.context.length === 0) return q
    a = this.context[0]
    const b = a._iDisplayStart
    const c = a.oFeatures.bPaginate ? a._iDisplayLength : -1
    const d = a.fnRecordsDisplay()
    const e = c === -1
    return {
      page: e ? 0 : Math.floor(b / c),
      pages: e ? 1 : Math.ceil(d / c),
      start: b,
      end: a.fnDisplayEnd(),
      length: c,
      recordsTotal: a.fnRecordsTotal(),
      recordsDisplay: d,
      serverSide: Q(a) === 'ssp',
    }
  })
  z('page.len()', function (a) {
    return a === q
      ? this.context.length !== 0
        ? this.context[0]._iDisplayLength
        : q
      : this.iterator('table', function (b) {
          pb(b, a)
        })
  })
  const vc = function (a, b, c) {
    if (c) {
      const d = new B(a)
      d.one('draw', function () {
        c(d.ajax.json())
      })
    }
    if (Q(a) == 'ssp') ka(a, b)
    else {
      V(a, !0)
      const e = a.jqXHR
      e && e.readyState !== 4 && e.abort()
      Qa(a, [], function (h) {
        Ma(a)
        h = za(a, h)
        for (let f = 0, g = h.length; f < g; f++) ia(a, h[f])
        ka(a, b)
        V(a, !1)
      })
    }
  }
  z('ajax.json()', function () {
    const a = this.context
    if (a.length > 0) return a[0].json
  })
  z('ajax.params()', function () {
    const a = this.context
    if (a.length > 0) return a[0].oAjaxData
  })
  z('ajax.reload()', function (a, b) {
    return this.iterator('table', function (c) {
      vc(c, !1 === b, a)
    })
  })
  z('ajax.url()', function (a) {
    let b = this.context
    if (a === q) {
      if (b.length === 0) return q
      b = b[0]
      return b.ajax
        ? l.isPlainObject(b.ajax)
          ? b.ajax.url
          : b.ajax
        : b.sAjaxSource
    }
    return this.iterator('table', function (c) {
      l.isPlainObject(c.ajax) ? (c.ajax.url = a) : (c.ajax = a)
    })
  })
  z('ajax.url().load()', function (a, b) {
    return this.iterator('table', function (c) {
      vc(c, !1 === b, a)
    })
  })
  const zb = function (a, b, c, d, e) {
    let h = []
    let f
    let g
    let k
    let m = typeof b
    ;(b && m !== 'string' && m !== 'function' && b.length !== q) || (b = [b])
    m = 0
    for (g = b.length; m < g; m++) {
      const n =
        b[m] && b[m].split && !b[m].match(/[\[\(:]/) ? b[m].split(',') : [b[m]]
      let p = 0
      for (k = n.length; p < k; p++)
        (f = c(typeof n[p] === 'string' ? n[p].trim() : n[p])) &&
          f.length &&
          (h = h.concat(f))
    }
    a = M.selector[a]
    if (a.length) for (m = 0, g = a.length; m < g; m++) h = a[m](d, e, h)
    return Oa(h)
  }
  const Ab = function (a) {
    a || (a = {})
    a.filter && a.search === q && (a.search = a.filter)
    return l.extend({ search: 'none', order: 'current', page: 'all' }, a)
  }
  const Bb = function (a) {
    for (let b = 0, c = a.length; b < c; b++)
      if (a[b].length > 0)
        return (
          (a[0] = a[b]),
          (a[0].length = 1),
          (a.length = 1),
          (a.context = [a.context[b]]),
          a
        )
    a.length = 0
    return a
  }
  var ab = function (a, b) {
    let c = []
    const d = a.aiDisplay
    let e = a.aiDisplayMaster
    const h = b.search
    let f = b.order
    b = b.page
    if (Q(a) == 'ssp') return h === 'removed' ? [] : pa(0, e.length)
    if (b == 'current')
      for (f = a._iDisplayStart, a = a.fnDisplayEnd(); f < a; f++) c.push(d[f])
    else if (f == 'current' || f == 'applied')
      if (h == 'none') c = e.slice()
      else if (h == 'applied') c = d.slice()
      else if (h == 'removed') {
        const g = {}
        f = 0
        for (a = d.length; f < a; f++) g[d[f]] = null
        c = l.map(e, function (k) {
          return g.hasOwnProperty(k) ? null : k
        })
      } else if (f == 'index' || f == 'original')
        for (f = 0, a = a.aoData.length; f < a; f++)
          h == 'none'
            ? c.push(f)
            : ((e = l.inArray(f, d)),
              ((e === -1 && h == 'removed') || (e >= 0 && h == 'applied')) &&
                c.push(f))
    return c
  }
  const Gc = function (a, b, c) {
    let d
    return zb(
      'row',
      b,
      function (e) {
        let h = nc(e)
        const f = a.aoData
        if (h !== null && !c) return [h]
        d || (d = ab(a, c))
        if (h !== null && l.inArray(h, d) !== -1) return [h]
        if (e === null || e === q || e === '') return d
        if (typeof e === 'function')
          return l.map(d, function (k) {
            const m = f[k]
            return e(k, m._aData, m.nTr) ? k : null
          })
        if (e.nodeName) {
          h = e._DT_RowIndex
          const g = e._DT_CellIndex
          if (h !== q) return f[h] && f[h].nTr === e ? [h] : []
          if (g) return f[g.row] && f[g.row].nTr === e.parentNode ? [g.row] : []
          h = l(e).closest('*[data-dt-row]')
          return h.length ? [h.data('dt-row')] : []
        }
        if (
          typeof e === 'string' &&
          e.charAt(0) === '#' &&
          ((h = a.aIds[e.replace(/^#/, '')]), h !== q)
        )
          return [h.idx]
        h = qc(Fa(a.aoData, d, 'nTr'))
        return l(h)
          .filter(e)
          .map(function () {
            return this._DT_RowIndex
          })
          .toArray()
      },
      a,
      c,
    )
  }
  z('rows()', function (a, b) {
    a === q ? (a = '') : l.isPlainObject(a) && ((b = a), (a = ''))
    b = Ab(b)
    const c = this.iterator(
      'table',
      function (d) {
        return Gc(d, a, b)
      },
      1,
    )
    c.selector.rows = a
    c.selector.opts = b
    return c
  })
  z('rows().nodes()', function () {
    return this.iterator(
      'row',
      function (a, b) {
        return a.aoData[b].nTr || q
      },
      1,
    )
  })
  z('rows().data()', function () {
    return this.iterator(
      !0,
      'rows',
      function (a, b) {
        return Fa(a.aoData, b, '_aData')
      },
      1,
    )
  })
  J('rows().cache()', 'row().cache()', function (a) {
    return this.iterator(
      'row',
      function (b, c) {
        b = b.aoData[c]
        return a === 'search' ? b._aFilterData : b._aSortData
      },
      1,
    )
  })
  J('rows().invalidate()', 'row().invalidate()', function (a) {
    return this.iterator('row', function (b, c) {
      va(b, c, a)
    })
  })
  J('rows().indexes()', 'row().index()', function () {
    return this.iterator(
      'row',
      function (a, b) {
        return b
      },
      1,
    )
  })
  J('rows().ids()', 'row().id()', function (a) {
    for (var b = [], c = this.context, d = 0, e = c.length; d < e; d++)
      for (let h = 0, f = this[d].length; h < f; h++) {
        const g = c[d].rowIdFn(c[d].aoData[this[d][h]]._aData)
        b.push((!0 === a ? '#' : '') + g)
      }
    return new B(c, b)
  })
  J('rows().remove()', 'row().remove()', function () {
    const a = this
    this.iterator('row', function (b, c, d) {
      const e = b.aoData
      const h = e[c]
      let f
      let g
      e.splice(c, 1)
      let k = 0
      for (f = e.length; k < f; k++) {
        let m = e[k]
        const n = m.anCells
        m.nTr !== null && (m.nTr._DT_RowIndex = k)
        if (n !== null)
          for (m = 0, g = n.length; m < g; m++) n[m]._DT_CellIndex.row = k
      }
      Na(b.aiDisplayMaster, c)
      Na(b.aiDisplay, c)
      Na(a[d], c, !1)
      b._iRecordsDisplay > 0 && b._iRecordsDisplay--
      qb(b)
      c = b.rowIdFn(h._aData)
      c !== q && delete b.aIds[c]
    })
    this.iterator('table', function (b) {
      for (let c = 0, d = b.aoData.length; c < d; c++) b.aoData[c].idx = c
    })
    return this
  })
  z('rows.add()', function (a) {
    const b = this.iterator(
      'table',
      function (d) {
        let e
        const h = []
        let f = 0
        for (e = a.length; f < e; f++) {
          const g = a[f]
          g.nodeName && g.nodeName.toUpperCase() === 'TR'
            ? h.push(La(d, g)[0])
            : h.push(ia(d, g))
        }
        return h
      },
      1,
    )
    const c = this.rows(-1)
    c.pop()
    l.merge(c, b)
    return c
  })
  z('row()', function (a, b) {
    return Bb(this.rows(a, b))
  })
  z('row().data()', function (a) {
    const b = this.context
    if (a === q)
      return b.length && this.length ? b[0].aoData[this[0]]._aData : q
    const c = b[0].aoData[this[0]]
    c._aData = a
    Array.isArray(a) && c.nTr && c.nTr.id && ha(b[0].rowId)(a, c.nTr.id)
    va(b[0], this[0], 'data')
    return this
  })
  z('row().node()', function () {
    const a = this.context
    return a.length && this.length ? a[0].aoData[this[0]].nTr || null : null
  })
  z('row.add()', function (a) {
    a instanceof l && a.length && (a = a[0])
    const b = this.iterator('table', function (c) {
      return a.nodeName && a.nodeName.toUpperCase() === 'TR'
        ? La(c, a)[0]
        : ia(c, a)
    })
    return this.row(b[0])
  })
  l(A).on('plugin-init.dt', function (a, b) {
    a = new B(b)
    a.on('stateSaveParams', function (d, e, h) {
      d = e.rowIdFn
      e = e.aoData
      for (var f = [], g = 0; g < e.length; g++)
        e[g]._detailsShow && f.push(`#${d(e[g]._aData)}`)
      h.childRows = f
    })
    const c = a.state.loaded()
    c &&
      c.childRows &&
      a
        .rows(
          l.map(c.childRows, function (d) {
            return d.replace(/:/g, '\\:')
          }),
        )
        .every(function () {
          F(b, null, 'requestChild', [this])
        })
  })
  const Hc = function (a, b, c, d) {
    const e = []
    var h = function (f, g) {
      if (Array.isArray(f) || f instanceof l)
        for (var k = 0, m = f.length; k < m; k++) h(f[k], g)
      else
        f.nodeName && f.nodeName.toLowerCase() === 'tr'
          ? e.push(f)
          : ((k = l('<tr><td></td></tr>').addClass(g)),
            (l('td', k).addClass(g).html(f)[0].colSpan = na(a)),
            e.push(k[0]))
    }
    h(c, d)
    b._details && b._details.detach()
    b._details = l(e)
    b._detailsShow && b._details.insertAfter(b.nTr)
  }
  const wc = u.util.throttle(function (a) {
    Da(a[0])
  }, 500)
  const Cb = function (a, b) {
    const c = a.context
    c.length &&
      (a = c[0].aoData[b !== q ? b : a[0]]) &&
      a._details &&
      (a._details.remove(),
      (a._detailsShow = q),
      (a._details = q),
      l(a.nTr).removeClass('dt-hasChild'),
      wc(c))
  }
  const xc = function (a, b) {
    const c = a.context
    if (c.length && a.length) {
      const d = c[0].aoData[a[0]]
      d._details &&
        ((d._detailsShow = b)
          ? (d._details.insertAfter(d.nTr), l(d.nTr).addClass('dt-hasChild'))
          : (d._details.detach(), l(d.nTr).removeClass('dt-hasChild')),
        F(c[0], null, 'childRow', [b, a.row(a[0])]),
        Ic(c[0]),
        wc(c))
    }
  }
  var Ic = function (a) {
    const b = new B(a)
    const c = a.aoData
    b.off(
      'draw.dt.DT_details column-sizing.dt.DT_details destroy.dt.DT_details',
    )
    U(c, '_details').length > 0 &&
      (b.on('draw.dt.DT_details', function (d, e) {
        a === e &&
          b
            .rows({ page: 'current' })
            .eq(0)
            .each(function (h) {
              h = c[h]
              h._detailsShow && h._details.insertAfter(h.nTr)
            })
      }),
      b.on('column-sizing.dt.DT_details', function (d, e, h, f) {
        if (a === e)
          for (e = na(e), h = 0, f = c.length; h < f; h++)
            (d = c[h]),
              d._details &&
                d._details.children('td[colspan]').attr('colspan', e)
      }),
      b.on('destroy.dt.DT_details', function (d, e) {
        if (a === e)
          for (d = 0, e = c.length; d < e; d++) c[d]._details && Cb(b, d)
      }))
  }
  z('row().child()', function (a, b) {
    const c = this.context
    if (a === q)
      return c.length && this.length ? c[0].aoData[this[0]]._details : q
    !0 === a
      ? this.child.show()
      : !1 === a
      ? Cb(this)
      : c.length && this.length && Hc(c[0], c[0].aoData[this[0]], a, b)
    return this
  })
  z(['row().child.show()', 'row().child().show()'], function (a) {
    xc(this, !0)
    return this
  })
  z(['row().child.hide()', 'row().child().hide()'], function () {
    xc(this, !1)
    return this
  })
  z(['row().child.remove()', 'row().child().remove()'], function () {
    Cb(this)
    return this
  })
  z('row().child.isShown()', function () {
    const a = this.context
    return a.length && this.length
      ? a[0].aoData[this[0]]._detailsShow || !1
      : !1
  })
  const Jc = /^([^:]+):(name|visIdx|visible)$/
  const yc = function (a, b, c, d, e) {
    c = []
    d = 0
    for (let h = e.length; d < h; d++) c.push(T(a, e[d], b))
    return c
  }
  const Kc = function (a, b, c) {
    const d = a.aoColumns
    const e = U(d, 'sName')
    const h = U(d, 'nTh')
    return zb(
      'column',
      b,
      function (f) {
        let g = nc(f)
        if (f === '') return pa(d.length)
        if (g !== null) return [g >= 0 ? g : d.length + g]
        if (typeof f === 'function') {
          const k = ab(a, c)
          return l.map(d, function (p, t) {
            return f(t, yc(a, t, 0, 0, k), h[t]) ? t : null
          })
        }
        const m = typeof f === 'string' ? f.match(Jc) : ''
        if (m)
          switch (m[2]) {
            case 'visIdx':
            case 'visible':
              g = parseInt(m[1], 10)
              if (g < 0) {
                const n = l.map(d, function (p, t) {
                  return p.bVisible ? t : null
                })
                return [n[n.length + g]]
              }
              return [ta(a, g)]
            case 'name':
              return l.map(e, function (p, t) {
                return p === m[1] ? t : null
              })
            default:
              return []
          }
        if (f.nodeName && f._DT_CellIndex) return [f._DT_CellIndex.column]
        g = l(h)
          .filter(f)
          .map(function () {
            return l.inArray(this, h)
          })
          .toArray()
        if (g.length || !f.nodeName) return g
        g = l(f).closest('*[data-dt-column]')
        return g.length ? [g.data('dt-column')] : []
      },
      a,
      c,
    )
  }
  z('columns()', function (a, b) {
    a === q ? (a = '') : l.isPlainObject(a) && ((b = a), (a = ''))
    b = Ab(b)
    const c = this.iterator(
      'table',
      function (d) {
        return Kc(d, a, b)
      },
      1,
    )
    c.selector.cols = a
    c.selector.opts = b
    return c
  })
  J('columns().header()', 'column().header()', function (a, b) {
    return this.iterator(
      'column',
      function (c, d) {
        return c.aoColumns[d].nTh
      },
      1,
    )
  })
  J('columns().footer()', 'column().footer()', function (a, b) {
    return this.iterator(
      'column',
      function (c, d) {
        return c.aoColumns[d].nTf
      },
      1,
    )
  })
  J('columns().data()', 'column().data()', function () {
    return this.iterator('column-rows', yc, 1)
  })
  J('columns().dataSrc()', 'column().dataSrc()', function () {
    return this.iterator(
      'column',
      function (a, b) {
        return a.aoColumns[b].mData
      },
      1,
    )
  })
  J('columns().cache()', 'column().cache()', function (a) {
    return this.iterator(
      'column-rows',
      function (b, c, d, e, h) {
        return Fa(
          b.aoData,
          h,
          a === 'search' ? '_aFilterData' : '_aSortData',
          c,
        )
      },
      1,
    )
  })
  J('columns().nodes()', 'column().nodes()', function () {
    return this.iterator(
      'column-rows',
      function (a, b, c, d, e) {
        return Fa(a.aoData, e, 'anCells', b)
      },
      1,
    )
  })
  J('columns().visible()', 'column().visible()', function (a, b) {
    const c = this
    const d = this.iterator('column', function (e, h) {
      if (a === q) return e.aoColumns[h].bVisible
      let f = e.aoColumns
      const g = f[h]
      const k = e.aoData
      let m
      if (a !== q && g.bVisible !== a) {
        if (a) {
          const n = l.inArray(!0, U(f, 'bVisible'), h + 1)
          f = 0
          for (m = k.length; f < m; f++) {
            const p = k[f].nTr
            e = k[f].anCells
            p && p.insertBefore(e[h], e[n] || null)
          }
        } else l(U(e.aoData, 'anCells', h)).detach()
        g.bVisible = a
      }
    })
    a !== q &&
      this.iterator('table', function (e) {
        xa(e, e.aoHeader)
        xa(e, e.aoFooter)
        e.aiDisplay.length ||
          l(e.nTBody).find('td[colspan]').attr('colspan', na(e))
        Da(e)
        c.iterator('column', function (h, f) {
          F(h, null, 'column-visibility', [h, f, a, b])
        })
        ;(b === q || b) && c.columns.adjust()
      })
    return d
  })
  J('columns().indexes()', 'column().index()', function (a) {
    return this.iterator(
      'column',
      function (b, c) {
        return a === 'visible' ? ua(b, c) : c
      },
      1,
    )
  })
  z('columns.adjust()', function () {
    return this.iterator(
      'table',
      function (a) {
        sa(a)
      },
      1,
    )
  })
  z('column.index()', function (a, b) {
    if (this.context.length !== 0) {
      const c = this.context[0]
      if (a === 'fromVisible' || a === 'toData') return ta(c, b)
      if (a === 'fromData' || a === 'toVisible') return ua(c, b)
    }
  })
  z('column()', function (a, b) {
    return Bb(this.columns(a, b))
  })
  const Lc = function (a, b, c) {
    const d = a.aoData
    const e = ab(a, c)
    const h = qc(Fa(d, e, 'anCells'))
    const f = l(rc([], h))
    let g
    const k = a.aoColumns.length
    let m
    let n
    let p
    let t
    let v
    let x
    return zb(
      'cell',
      b,
      function (w) {
        let r = typeof w === 'function'
        if (w === null || w === q || r) {
          m = []
          n = 0
          for (p = e.length; n < p; n++)
            for (g = e[n], t = 0; t < k; t++)
              (v = { row: g, column: t }),
                r
                  ? ((x = d[g]),
                    w(v, T(a, g, t), x.anCells ? x.anCells[t] : null) &&
                      m.push(v))
                  : m.push(v)
          return m
        }
        if (l.isPlainObject(w))
          return w.column !== q && w.row !== q && l.inArray(w.row, e) !== -1
            ? [w]
            : []
        r = f
          .filter(w)
          .map(function (C, G) {
            return { row: G._DT_CellIndex.row, column: G._DT_CellIndex.column }
          })
          .toArray()
        if (r.length || !w.nodeName) return r
        x = l(w).closest('*[data-dt-row]')
        return x.length
          ? [{ row: x.data('dt-row'), column: x.data('dt-column') }]
          : []
      },
      a,
      c,
    )
  }
  z('cells()', function (a, b, c) {
    l.isPlainObject(a) &&
      (a.row === q ? ((c = a), (a = null)) : ((c = b), (b = null)))
    l.isPlainObject(b) && ((c = b), (b = null))
    if (b === null || b === q)
      return this.iterator('table', function (n) {
        return Lc(n, a, Ab(c))
      })
    let d = c ? { page: c.page, order: c.order, search: c.search } : {}
    const e = this.columns(b, d)
    const h = this.rows(a, d)
    let f
    let g
    let k
    let m
    d = this.iterator(
      'table',
      function (n, p) {
        n = []
        f = 0
        for (g = h[p].length; f < g; f++)
          for (k = 0, m = e[p].length; k < m; k++)
            n.push({ row: h[p][f], column: e[p][k] })
        return n
      },
      1,
    )
    d = c && c.selected ? this.cells(d, c) : d
    l.extend(d.selector, { cols: b, rows: a, opts: c })
    return d
  })
  J('cells().nodes()', 'cell().node()', function () {
    return this.iterator(
      'cell',
      function (a, b, c) {
        return (a = a.aoData[b]) && a.anCells ? a.anCells[c] : q
      },
      1,
    )
  })
  z('cells().data()', function () {
    return this.iterator(
      'cell',
      function (a, b, c) {
        return T(a, b, c)
      },
      1,
    )
  })
  J('cells().cache()', 'cell().cache()', function (a) {
    a = a === 'search' ? '_aFilterData' : '_aSortData'
    return this.iterator(
      'cell',
      function (b, c, d) {
        return b.aoData[c][a][d]
      },
      1,
    )
  })
  J('cells().render()', 'cell().render()', function (a) {
    return this.iterator(
      'cell',
      function (b, c, d) {
        return T(b, c, d, a)
      },
      1,
    )
  })
  J('cells().indexes()', 'cell().index()', function () {
    return this.iterator(
      'cell',
      function (a, b, c) {
        return { row: b, column: c, columnVisible: ua(a, c) }
      },
      1,
    )
  })
  J('cells().invalidate()', 'cell().invalidate()', function (a) {
    return this.iterator('cell', function (b, c, d) {
      va(b, c, a, d)
    })
  })
  z('cell()', function (a, b, c) {
    return Bb(this.cells(a, b, c))
  })
  z('cell().data()', function (a) {
    const b = this.context
    const c = this[0]
    if (a === q)
      return b.length && c.length ? T(b[0], c[0].row, c[0].column) : q
    Ib(b[0], c[0].row, c[0].column, a)
    va(b[0], c[0].row, 'data', c[0].column)
    return this
  })
  z('order()', function (a, b) {
    const c = this.context
    if (a === q) return c.length !== 0 ? c[0].aaSorting : q
    typeof a === 'number'
      ? (a = [[a, b]])
      : a.length &&
        !Array.isArray(a[0]) &&
        (a = Array.prototype.slice.call(arguments))
    return this.iterator('table', function (d) {
      d.aaSorting = a.slice()
    })
  })
  z('order.listener()', function (a, b, c) {
    return this.iterator('table', function (d) {
      kb(d, a, b, c)
    })
  })
  z('order.fixed()', function (a) {
    if (!a) {
      let b = this.context
      b = b.length ? b[0].aaSortingFixed : q
      return Array.isArray(b) ? { pre: b } : b
    }
    return this.iterator('table', function (c) {
      c.aaSortingFixed = l.extend(!0, {}, a)
    })
  })
  z(['columns().order()', 'column().order()'], function (a) {
    const b = this
    return this.iterator('table', function (c, d) {
      const e = []
      l.each(b[d], function (h, f) {
        e.push([f, a])
      })
      c.aaSorting = e
    })
  })
  z('search()', function (a, b, c, d) {
    const e = this.context
    return a === q
      ? e.length !== 0
        ? e[0].oPreviousSearch.sSearch
        : q
      : this.iterator('table', function (h) {
          h.oFeatures.bFilter &&
            ya(
              h,
              l.extend({}, h.oPreviousSearch, {
                sSearch: `${a}`,
                bRegex: b === null ? !1 : b,
                bSmart: c === null ? !0 : c,
                bCaseInsensitive: d === null ? !0 : d,
              }),
              1,
            )
        })
  })
  J('columns().search()', 'column().search()', function (a, b, c, d) {
    return this.iterator('column', function (e, h) {
      const f = e.aoPreSearchCols
      if (a === q) return f[h].sSearch
      e.oFeatures.bFilter &&
        (l.extend(f[h], {
          sSearch: `${a}`,
          bRegex: b === null ? !1 : b,
          bSmart: c === null ? !0 : c,
          bCaseInsensitive: d === null ? !0 : d,
        }),
        ya(e, e.oPreviousSearch, 1))
    })
  })
  z('state()', function () {
    return this.context.length ? this.context[0].oSavedState : null
  })
  z('state.clear()', function () {
    return this.iterator('table', function (a) {
      a.fnStateSaveCallback.call(a.oInstance, a, {})
    })
  })
  z('state.loaded()', function () {
    return this.context.length ? this.context[0].oLoadedState : null
  })
  z('state.save()', function () {
    return this.iterator('table', function (a) {
      Da(a)
    })
  })
  u.versionCheck = u.fnVersionCheck = function (a) {
    const b = u.version.split('.')
    a = a.split('.')
    for (var c, d, e = 0, h = a.length; e < h; e++)
      if (
        ((c = parseInt(b[e], 10) || 0), (d = parseInt(a[e], 10) || 0), c !== d)
      )
        return c > d
    return !0
  }
  u.isDataTable = u.fnIsDataTable = function (a) {
    const b = l(a).get(0)
    let c = !1
    if (a instanceof u.Api) return !0
    l.each(u.settings, function (d, e) {
      d = e.nScrollHead ? l('table', e.nScrollHead)[0] : null
      const h = e.nScrollFoot ? l('table', e.nScrollFoot)[0] : null
      if (e.nTable === b || d === b || h === b) c = !0
    })
    return c
  }
  u.tables = u.fnTables = function (a) {
    let b = !1
    l.isPlainObject(a) && ((b = a.api), (a = a.visible))
    const c = l.map(u.settings, function (d) {
      if (!a || (a && l(d.nTable).is(':visible'))) return d.nTable
    })
    return b ? new B(c) : c
  }
  u.camelToHungarian = P
  z('$()', function (a, b) {
    b = this.rows(b).nodes()
    b = l(b)
    return l([].concat(b.filter(a).toArray(), b.find(a).toArray()))
  })
  l.each(['on', 'one', 'off'], function (a, b) {
    z(`${b}()`, function () {
      const c = Array.prototype.slice.call(arguments)
      c[0] = l
        .map(c[0].split(/\s/), function (e) {
          return e.match(/\.dt\b/) ? e : `${e}.dt`
        })
        .join(' ')
      const d = l(this.tables().nodes())
      d[b].apply(d, c)
      return this
    })
  })
  z('clear()', function () {
    return this.iterator('table', function (a) {
      Ma(a)
    })
  })
  z('settings()', function () {
    return new B(this.context, this.context)
  })
  z('init()', function () {
    const a = this.context
    return a.length ? a[0].oInit : null
  })
  z('data()', function () {
    return this.iterator('table', function (a) {
      return U(a.aoData, '_aData')
    }).flatten()
  })
  z('destroy()', function (a) {
    a = a || !1
    return this.iterator('table', function (b) {
      let c = b.oClasses
      const d = b.nTable
      let e = b.nTBody
      let h = b.nTHead
      let f = b.nTFoot
      const g = l(d)
      e = l(e)
      const k = l(b.nTableWrapper)
      const m = l.map(b.aoData, function (p) {
        return p.nTr
      })
      let n
      b.bDestroying = !0
      F(b, 'aoDestroyCallback', 'destroy', [b])
      a || new B(b).columns().visible(!0)
      k.off('.DT').find(':not(tbody *)').off('.DT')
      l(y).off(`.DT-${b.sInstance}`)
      d != h.parentNode && (g.children('thead').detach(), g.append(h))
      f && d != f.parentNode && (g.children('tfoot').detach(), g.append(f))
      b.aaSorting = []
      b.aaSortingFixed = []
      Va(b)
      l(m).removeClass(b.asStripeClasses.join(' '))
      l('th, td', h).removeClass(
        `${c.sSortable} ${c.sSortableAsc} ${c.sSortableDesc} ${c.sSortableNone}`,
      )
      e.children().detach()
      e.append(m)
      h = b.nTableWrapper.parentNode
      f = a ? 'remove' : 'detach'
      g[f]()
      k[f]()
      !a &&
        h &&
        (h.insertBefore(d, b.nTableReinsertBefore),
        g.css('width', b.sDestroyWidth).removeClass(c.sTable),
        (n = b.asDestroyStripes.length) &&
          e.children().each(function (p) {
            l(this).addClass(b.asDestroyStripes[p % n])
          }))
      c = l.inArray(b, u.settings)
      c !== -1 && u.settings.splice(c, 1)
    })
  })
  l.each(['column', 'row', 'cell'], function (a, b) {
    z(`${b}s().every()`, function (c) {
      const d = this.selector.opts
      const e = this
      return this.iterator(b, function (h, f, g, k, m) {
        c.call(e[b](f, b === 'cell' ? g : d, b === 'cell' ? d : q), f, g, k, m)
      })
    })
  })
  z('i18n()', function (a, b, c) {
    const d = this.context[0]
    a = ma(a)(d.oLanguage)
    a === q && (a = b)
    c !== q && l.isPlainObject(a) && (a = a[c] !== q ? a[c] : a._)
    return a.replace('%d', c)
  })
  u.version = '1.12.1'
  u.settings = []
  u.models = {}
  u.models.oSearch = {
    bCaseInsensitive: !0,
    sSearch: '',
    bRegex: !1,
    bSmart: !0,
    return: !1,
  }
  u.models.oRow = {
    nTr: null,
    anCells: null,
    _aData: [],
    _aSortData: null,
    _aFilterData: null,
    _sFilterRow: null,
    _sRowStripe: '',
    src: null,
    idx: -1,
  }
  u.models.oColumn = {
    idx: null,
    aDataSort: null,
    asSorting: null,
    bSearchable: null,
    bSortable: null,
    bVisible: null,
    _sManualType: null,
    _bAttrSrc: !1,
    fnCreatedCell: null,
    fnGetData: null,
    fnSetData: null,
    mData: null,
    mRender: null,
    nTh: null,
    nTf: null,
    sClass: null,
    sContentPadding: null,
    sDefaultContent: null,
    sName: null,
    sSortDataType: 'std',
    sSortingClass: null,
    sSortingClassJUI: null,
    sTitle: null,
    sType: null,
    sWidth: null,
    sWidthOrig: null,
  }
  u.defaults = {
    aaData: null,
    aaSorting: [[0, 'asc']],
    aaSortingFixed: [],
    ajax: null,
    aLengthMenu: [10, 25, 50, 100],
    aoColumns: null,
    aoColumnDefs: null,
    aoSearchCols: [],
    asStripeClasses: null,
    bAutoWidth: !0,
    bDeferRender: !1,
    bDestroy: !1,
    bFilter: !0,
    bInfo: !0,
    bLengthChange: !0,
    bPaginate: !0,
    bProcessing: !1,
    bRetrieve: !1,
    bScrollCollapse: !1,
    bServerSide: !1,
    bSort: !0,
    bSortMulti: !0,
    bSortCellsTop: !1,
    bSortClasses: !0,
    bStateSave: !1,
    fnCreatedRow: null,
    fnDrawCallback: null,
    fnFooterCallback: null,
    fnFormatNumber(a) {
      return a
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, this.oLanguage.sThousands)
    },
    fnHeaderCallback: null,
    fnInfoCallback: null,
    fnInitComplete: null,
    fnPreDrawCallback: null,
    fnRowCallback: null,
    fnServerData: null,
    fnServerParams: null,
    fnStateLoadCallback(a) {
      try {
        return JSON.parse(
          (a.iStateDuration === -1 ? sessionStorage : localStorage).getItem(
            `DataTables_${a.sInstance}_${location.pathname}`,
          ),
        )
      } catch (b) {
        return {}
      }
    },
    fnStateLoadParams: null,
    fnStateLoaded: null,
    fnStateSaveCallback(a, b) {
      try {
        ;(a.iStateDuration === -1 ? sessionStorage : localStorage).setItem(
          `DataTables_${a.sInstance}_${location.pathname}`,
          JSON.stringify(b),
        )
      } catch (c) {}
    },
    fnStateSaveParams: null,
    iStateDuration: 7200,
    iDeferLoading: null,
    iDisplayLength: 10,
    iDisplayStart: 0,
    iTabIndex: 0,
    oClasses: {},
    oLanguage: {
      oAria: {
        sSortAscending: ': activate to sort column ascending',
        sSortDescending: ': activate to sort column descending',
      },
      oPaginate: {
        sFirst: 'First',
        sLast: 'Last',
        sNext: 'Next',
        sPrevious: 'Previous',
      },
      sEmptyTable: 'No data available in table',
      sInfo: 'Showing _START_ to _END_ of _TOTAL_ entries',
      sInfoEmpty: 'Showing 0 to 0 of 0 entries',
      sInfoFiltered: '(filtered from _MAX_ total entries)',
      sInfoPostFix: '',
      sDecimal: '',
      sThousands: ',',
      sLengthMenu: 'Show _MENU_ entries',
      sLoadingRecords: 'Loading...',
      sProcessing: '',
      sSearch: 'Search:',
      sSearchPlaceholder: '',
      sUrl: '',
      sZeroRecords: 'No matching records found',
    },
    oSearch: l.extend({}, u.models.oSearch),
    sAjaxDataProp: 'data',
    sAjaxSource: null,
    sDom: 'lfrtip',
    searchDelay: null,
    sPaginationType: 'simple_numbers',
    sScrollX: '',
    sScrollXInner: '',
    sScrollY: '',
    sServerMethod: 'GET',
    renderer: null,
    rowId: 'DT_RowId',
  }
  E(u.defaults)
  u.defaults.column = {
    aDataSort: null,
    iDataSort: -1,
    asSorting: ['asc', 'desc'],
    bSearchable: !0,
    bSortable: !0,
    bVisible: !0,
    fnCreatedCell: null,
    mData: null,
    mRender: null,
    sCellType: 'td',
    sClass: '',
    sContentPadding: '',
    sDefaultContent: null,
    sName: '',
    sSortDataType: 'std',
    sTitle: null,
    sType: null,
    sWidth: null,
  }
  E(u.defaults.column)
  u.models.oSettings = {
    oFeatures: {
      bAutoWidth: null,
      bDeferRender: null,
      bFilter: null,
      bInfo: null,
      bLengthChange: null,
      bPaginate: null,
      bProcessing: null,
      bServerSide: null,
      bSort: null,
      bSortMulti: null,
      bSortClasses: null,
      bStateSave: null,
    },
    oScroll: {
      bCollapse: null,
      iBarWidth: 0,
      sX: null,
      sXInner: null,
      sY: null,
    },
    oLanguage: { fnInfoCallback: null },
    oBrowser: {
      bScrollOversize: !1,
      bScrollbarLeft: !1,
      bBounding: !1,
      barWidth: 0,
    },
    ajax: null,
    aanFeatures: [],
    aoData: [],
    aiDisplay: [],
    aiDisplayMaster: [],
    aIds: {},
    aoColumns: [],
    aoHeader: [],
    aoFooter: [],
    oPreviousSearch: {},
    aoPreSearchCols: [],
    aaSorting: null,
    aaSortingFixed: [],
    asStripeClasses: null,
    asDestroyStripes: [],
    sDestroyWidth: 0,
    aoRowCallback: [],
    aoHeaderCallback: [],
    aoFooterCallback: [],
    aoDrawCallback: [],
    aoRowCreatedCallback: [],
    aoPreDrawCallback: [],
    aoInitComplete: [],
    aoStateSaveParams: [],
    aoStateLoadParams: [],
    aoStateLoaded: [],
    sTableId: '',
    nTable: null,
    nTHead: null,
    nTFoot: null,
    nTBody: null,
    nTableWrapper: null,
    bDeferLoading: !1,
    bInitialised: !1,
    aoOpenRows: [],
    sDom: null,
    searchDelay: null,
    sPaginationType: 'two_button',
    iStateDuration: 0,
    aoStateSave: [],
    aoStateLoad: [],
    oSavedState: null,
    oLoadedState: null,
    sAjaxSource: null,
    sAjaxDataProp: null,
    jqXHR: null,
    json: q,
    oAjaxData: q,
    fnServerData: null,
    aoServerParams: [],
    sServerMethod: null,
    fnFormatNumber: null,
    aLengthMenu: null,
    iDraw: 0,
    bDrawing: !1,
    iDrawError: -1,
    _iDisplayLength: 10,
    _iDisplayStart: 0,
    _iRecordsTotal: 0,
    _iRecordsDisplay: 0,
    oClasses: {},
    bFiltered: !1,
    bSorted: !1,
    bSortCellsTop: null,
    oInit: null,
    aoDestroyCallback: [],
    fnRecordsTotal() {
      return Q(this) == 'ssp'
        ? 1 * this._iRecordsTotal
        : this.aiDisplayMaster.length
    },
    fnRecordsDisplay() {
      return Q(this) == 'ssp'
        ? 1 * this._iRecordsDisplay
        : this.aiDisplay.length
    },
    fnDisplayEnd() {
      const a = this._iDisplayLength
      const b = this._iDisplayStart
      const c = b + a
      const d = this.aiDisplay.length
      const e = this.oFeatures
      const h = e.bPaginate
      return e.bServerSide
        ? !1 === h || a === -1
          ? b + d
          : Math.min(b + a, this._iRecordsDisplay)
        : !h || c > d || a === -1
        ? d
        : c
    },
    oInstance: null,
    sInstance: null,
    iTabIndex: 0,
    nScrollHead: null,
    nScrollFoot: null,
    aLastSort: [],
    oPlugins: {},
    rowIdFn: null,
    rowId: null,
  }
  u.ext = M = {
    buttons: {},
    classes: {},
    builder: 'bs5/dt-1.12.1',
    errMode: 'alert',
    feature: [],
    search: [],
    selector: { cell: [], column: [], row: [] },
    internal: {},
    legacy: { ajax: null },
    pager: {},
    renderer: { pageButton: {}, header: {} },
    order: {},
    type: { detect: [], search: {}, order: {} },
    _unique: 0,
    fnVersionCheck: u.fnVersionCheck,
    iApiIndex: 0,
    oJUIClasses: {},
    sVersion: u.version,
  }
  l.extend(M, {
    afnFiltering: M.search,
    aTypes: M.type.detect,
    ofnSearch: M.type.search,
    oSort: M.type.order,
    afnSortData: M.order,
    aoFeatures: M.feature,
    oApi: M.internal,
    oStdClasses: M.classes,
    oPagination: M.pager,
  })
  l.extend(u.ext.classes, {
    sTable: 'dataTable',
    sNoFooter: 'no-footer',
    sPageButton: 'paginate_button',
    sPageButtonActive: 'current',
    sPageButtonDisabled: 'disabled',
    sStripeOdd: 'odd',
    sStripeEven: 'even',
    sRowEmpty: 'dataTables_empty',
    sWrapper: 'dataTables_wrapper',
    sFilter: 'dataTables_filter',
    sInfo: 'dataTables_info',
    sPaging: 'dataTables_paginate paging_',
    sLength: 'dataTables_length',
    sProcessing: 'dataTables_processing',
    sSortAsc: 'sorting_asc',
    sSortDesc: 'sorting_desc',
    sSortable: 'sorting',
    sSortableAsc: 'sorting_desc_disabled',
    sSortableDesc: 'sorting_asc_disabled',
    sSortableNone: 'sorting_disabled',
    sSortColumn: 'sorting_',
    sFilterInput: '',
    sLengthSelect: '',
    sScrollWrapper: 'dataTables_scroll',
    sScrollHead: 'dataTables_scrollHead',
    sScrollHeadInner: 'dataTables_scrollHeadInner',
    sScrollBody: 'dataTables_scrollBody',
    sScrollFoot: 'dataTables_scrollFoot',
    sScrollFootInner: 'dataTables_scrollFootInner',
    sHeaderTH: '',
    sFooterTH: '',
    sSortJUIAsc: '',
    sSortJUIDesc: '',
    sSortJUI: '',
    sSortJUIAscAllowed: '',
    sSortJUIDescAllowed: '',
    sSortJUIWrapper: '',
    sSortIcon: '',
    sJUIHeader: '',
    sJUIFooter: '',
  })
  var ic = u.ext.pager
  l.extend(ic, {
    simple(a, b) {
      return ['previous', 'next']
    },
    full(a, b) {
      return ['first', 'previous', 'next', 'last']
    },
    numbers(a, b) {
      return [Ea(a, b)]
    },
    simple_numbers(a, b) {
      return ['previous', Ea(a, b), 'next']
    },
    full_numbers(a, b) {
      return ['first', 'previous', Ea(a, b), 'next', 'last']
    },
    first_last_numbers(a, b) {
      return ['first', Ea(a, b), 'last']
    },
    _numbers: Ea,
    numbers_length: 7,
  })
  l.extend(!0, u.ext.renderer, {
    pageButton: {
      _(a, b, c, d, e, h) {
        const f = a.oClasses
        const g = a.oLanguage.oPaginate
        const k = a.oLanguage.oAria.paginate || {}
        let m
        let n
        let p = 0
        var t = function (x, w) {
          let r
          const C = f.sPageButtonDisabled
          const G = function (I) {
            Ta(a, I.data.action, !0)
          }
          let ba = 0
          for (r = w.length; ba < r; ba++) {
            const L = w[ba]
            if (Array.isArray(L)) {
              var O = l(`<${L.DT_el || 'div'}/>`).appendTo(x)
              t(O, L)
            } else {
              m = null
              n = L
              O = a.iTabIndex
              switch (L) {
                case 'ellipsis':
                  x.append('<span class="ellipsis">&#x2026;</span>')
                  break
                case 'first':
                  m = g.sFirst
                  e === 0 && ((O = -1), (n += ` ${C}`))
                  break
                case 'previous':
                  m = g.sPrevious
                  e === 0 && ((O = -1), (n += ` ${C}`))
                  break
                case 'next':
                  m = g.sNext
                  if (h === 0 || e === h - 1) (O = -1), (n += ` ${C}`)
                  break
                case 'last':
                  m = g.sLast
                  if (h === 0 || e === h - 1) (O = -1), (n += ` ${C}`)
                  break
                default:
                  ;(m = a.fnFormatNumber(L + 1)),
                    (n = e === L ? f.sPageButtonActive : '')
              }
              m !== null &&
                ((O = l('<a>', {
                  'class': `${f.sPageButton} ${n}`,
                  'aria-controls': a.sTableId,
                  'aria-label': k[L],
                  'data-dt-idx': p,
                  'tabindex': O,
                  'id':
                    c === 0 && typeof L === 'string'
                      ? `${a.sTableId}_${L}`
                      : null,
                })
                  .html(m)
                  .appendTo(x)),
                sb(O, { action: L }, G),
                p++)
            }
          }
        }
        try {
          var v = l(b).find(A.activeElement).data('dt-idx')
        } catch (x) {}
        t(l(b).empty(), d)
        v !== q && l(b).find(`[data-dt-idx=${v}]`).trigger('focus')
      },
    },
  })
  l.extend(u.ext.type.detect, [
    function (a, b) {
      b = b.oLanguage.sDecimal
      return yb(a, b) ? `num${b}` : null
    },
    function (a, b) {
      if (a && !(a instanceof Date) && !Dc.test(a)) return null
      b = Date.parse(a)
      return (b !== null && !isNaN(b)) || aa(a) ? 'date' : null
    },
    function (a, b) {
      b = b.oLanguage.sDecimal
      return yb(a, b, !0) ? `num-fmt${b}` : null
    },
    function (a, b) {
      b = b.oLanguage.sDecimal
      return pc(a, b) ? `html-num${b}` : null
    },
    function (a, b) {
      b = b.oLanguage.sDecimal
      return pc(a, b, !0) ? `html-num-fmt${b}` : null
    },
    function (a, b) {
      return aa(a) || (typeof a === 'string' && a.indexOf('<') !== -1)
        ? 'html'
        : null
    },
  ])
  l.extend(u.ext.type.search, {
    html(a) {
      return aa(a)
        ? a
        : typeof a === 'string'
        ? a.replace(mc, ' ').replace(Ya, '')
        : ''
    },
    string(a) {
      return aa(a) ? a : typeof a === 'string' ? a.replace(mc, ' ') : a
    },
  })
  var Xa = function (a, b, c, d) {
    if (a !== 0 && (!a || a === '-')) return -Infinity
    b && (a = oc(a, b))
    a.replace && (c && (a = a.replace(c, '')), d && (a = a.replace(d, '')))
    return 1 * a
  }
  l.extend(M.type.order, {
    'date-pre': function (a) {
      a = Date.parse(a)
      return isNaN(a) ? -Infinity : a
    },
    'html-pre': function (a) {
      return aa(a)
        ? ''
        : a.replace
        ? a.replace(/<.*?>/g, '').toLowerCase()
        : `${a}`
    },
    'string-pre': function (a) {
      return aa(a)
        ? ''
        : typeof a === 'string'
        ? a.toLowerCase()
        : a.toString
        ? a.toString()
        : ''
    },
    'string-asc': function (a, b) {
      return a < b ? -1 : a > b ? 1 : 0
    },
    'string-desc': function (a, b) {
      return a < b ? 1 : a > b ? -1 : 0
    },
  })
  bb('')
  l.extend(!0, u.ext.renderer, {
    header: {
      _(a, b, c, d) {
        l(a.nTable).on('order.dt.DT', function (e, h, f, g) {
          a === h &&
            ((e = c.idx),
            b
              .removeClass(`${d.sSortAsc} ${d.sSortDesc}`)
              .addClass(
                g[e] == 'asc'
                  ? d.sSortAsc
                  : g[e] == 'desc'
                  ? d.sSortDesc
                  : c.sSortingClass,
              ))
        })
      },
      jqueryui(a, b, c, d) {
        l('<div/>')
          .addClass(d.sSortJUIWrapper)
          .append(b.contents())
          .append(l('<span/>').addClass(`${d.sSortIcon} ${c.sSortingClassJUI}`))
          .appendTo(b)
        l(a.nTable).on('order.dt.DT', function (e, h, f, g) {
          a === h &&
            ((e = c.idx),
            b
              .removeClass(`${d.sSortAsc} ${d.sSortDesc}`)
              .addClass(
                g[e] == 'asc'
                  ? d.sSortAsc
                  : g[e] == 'desc'
                  ? d.sSortDesc
                  : c.sSortingClass,
              ),
            b
              .find(`span.${d.sSortIcon}`)
              .removeClass(
                `${d.sSortJUIAsc} ${d.sSortJUIDesc} ${d.sSortJUI} ${d.sSortJUIAscAllowed} ${d.sSortJUIDescAllowed}`,
              )
              .addClass(
                g[e] == 'asc'
                  ? d.sSortJUIAsc
                  : g[e] == 'desc'
                  ? d.sSortJUIDesc
                  : c.sSortingClassJUI,
              ))
        })
      },
    },
  })
  var $a = function (a) {
    Array.isArray(a) && (a = a.join(','))
    return typeof a === 'string'
      ? a
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
      : a
  }
  var kc = !1
  let zc = ','
  let Ac = '.'
  if (Intl)
    try {
      for (
        let Ha = new Intl.NumberFormat().formatToParts(100000.1), ra = 0;
        ra < Ha.length;
        ra++
      )
        Ha[ra].type === 'group'
          ? (zc = Ha[ra].value)
          : Ha[ra].type === 'decimal' && (Ac = Ha[ra].value)
    } catch (a) {}
  u.datetime = function (a, b) {
    const c = `datetime-detect-${a}`
    b || (b = 'en')
    u.ext.type.order[c] ||
      (u.ext.type.detect.unshift(function (d) {
        const e = Za(d, a, b)
        return d === '' || e ? c : !1
      }),
      (u.ext.type.order[`${c}-pre`] = function (d) {
        return Za(d, a, b) || 0
      }))
  }
  u.render = {
    date: wb('toLocaleDateString'),
    datetime: wb('toLocaleString'),
    time: wb('toLocaleTimeString'),
    number(a, b, c, d, e) {
      if (a === null || a === q) a = zc
      if (b === null || b === q) b = Ac
      return {
        display(h) {
          if (
            (typeof h !== 'number' && typeof h !== 'string') ||
            h === '' ||
            h === null
          )
            return h
          let f = h < 0 ? '-' : ''
          let g = parseFloat(h)
          if (isNaN(g)) return $a(h)
          g = g.toFixed(c)
          h = Math.abs(g)
          g = parseInt(h, 10)
          h = c ? b + (h - g).toFixed(c).substring(2) : ''
          g === 0 && parseFloat(h) === 0 && (f = '')
          return (
            f +
            (d || '') +
            g.toString().replace(/\B(?=(\d{3})+(?!\d))/g, a) +
            h +
            (e || '')
          )
        },
      }
    },
    text() {
      return { display: $a, filter: $a }
    },
  }
  l.extend(u.ext.internal, {
    _fnExternApiFunc: lc,
    _fnBuildAjax: Qa,
    _fnAjaxUpdate: Kb,
    _fnAjaxParameters: Tb,
    _fnAjaxUpdateDraw: Ub,
    _fnAjaxDataSrc: za,
    _fnAddColumn: cb,
    _fnColumnOptions: Ia,
    _fnAdjustColumnSizing: sa,
    _fnVisibleToColumnIndex: ta,
    _fnColumnIndexToVisible: ua,
    _fnVisbleColumns: na,
    _fnGetColumns: Ka,
    _fnColumnTypes: eb,
    _fnApplyColumnDefs: Hb,
    _fnHungarianMap: E,
    _fnCamelToHungarian: P,
    _fnLanguageCompat: la,
    _fnBrowserDetect: Fb,
    _fnAddData: ia,
    _fnAddTr: La,
    _fnNodeToDataIndex(a, b) {
      return b._DT_RowIndex !== q ? b._DT_RowIndex : null
    },
    _fnNodeToColumnIndex(a, b, c) {
      return l.inArray(c, a.aoData[b].anCells)
    },
    _fnGetCellData: T,
    _fnSetCellData: Ib,
    _fnSplitObjNotation: hb,
    _fnGetObjectDataFn: ma,
    _fnSetObjectDataFn: ha,
    _fnGetDataMaster: ib,
    _fnClearTable: Ma,
    _fnDeleteIndex: Na,
    _fnInvalidate: va,
    _fnGetRowElements: gb,
    _fnCreateTr: fb,
    _fnBuildHead: Jb,
    _fnDrawHead: xa,
    _fnDraw: ja,
    _fnReDraw: ka,
    _fnAddOptionsHtml: Mb,
    _fnDetectHeader: wa,
    _fnGetUniqueThs: Pa,
    _fnFeatureHtmlFilter: Ob,
    _fnFilterComplete: ya,
    _fnFilterCustom: Xb,
    _fnFilterColumn: Wb,
    _fnFilter: Vb,
    _fnFilterCreateSearch: nb,
    _fnEscapeRegex: ob,
    _fnFilterData: Yb,
    _fnFeatureHtmlInfo: Rb,
    _fnUpdateInfo: ac,
    _fnInfoMacros: bc,
    _fnInitialise: Aa,
    _fnInitComplete: Ra,
    _fnLengthChange: pb,
    _fnFeatureHtmlLength: Nb,
    _fnFeatureHtmlPaginate: Sb,
    _fnPageChange: Ta,
    _fnFeatureHtmlProcessing: Pb,
    _fnProcessingDisplay: V,
    _fnFeatureHtmlTable: Qb,
    _fnScrollDraw: Ja,
    _fnApplyToChildren: da,
    _fnCalculateColumnWidths: db,
    _fnThrottle: mb,
    _fnConvertToWidth: cc,
    _fnGetWidestNode: dc,
    _fnGetMaxLenString: ec,
    _fnStringToCss: K,
    _fnSortFlatten: oa,
    _fnSort: Lb,
    _fnSortAria: gc,
    _fnSortListener: rb,
    _fnSortAttachListener: kb,
    _fnSortingClasses: Va,
    _fnSortData: fc,
    _fnSaveState: Da,
    _fnLoadState: hc,
    _fnImplementState: tb,
    _fnSettingsFromNode: Wa,
    _fnLog: ea,
    _fnMap: Y,
    _fnBindAction: sb,
    _fnCallbackReg: R,
    _fnCallbackFire: F,
    _fnLengthOverflow: qb,
    _fnRenderer: lb,
    _fnDataSource: Q,
    _fnRowAttributes: jb,
    _fnExtend: ub,
    _fnCalculateEnd() {},
  })
  l.fn.dataTable = u
  u.$ = l
  l.fn.dataTableSettings = u.settings
  l.fn.dataTableExt = u.ext
  l.fn.DataTable = function (a) {
    return l(this).dataTable(a).api()
  }
  l.each(u, function (a, b) {
    l.fn.DataTable[a] = b
  })
  return u
})

/*!
 DataTables Bootstrap 5 integration
 2020 SpryMedia Ltd - datatables.net/license
*/
var $jscomp = $jscomp || {}
$jscomp.scope = {}
$jscomp.findInternal = function (a, b, c) {
  a instanceof String && (a = String(a))
  for (let e = a.length, d = 0; d < e; d++) {
    const f = a[d]
    if (b.call(c, f, d, a)) return { i: d, v: f }
  }
  return { i: -1, v: void 0 }
}
$jscomp.ASSUME_ES5 = !1
$jscomp.ASSUME_NO_NATIVE_MAP = !1
$jscomp.ASSUME_NO_NATIVE_SET = !1
$jscomp.SIMPLE_FROUND_POLYFILL = !1
$jscomp.ISOLATE_POLYFILLS = !1
$jscomp.defineProperty =
  $jscomp.ASSUME_ES5 || typeof Object.defineProperties === 'function'
    ? Object.defineProperty
    : function (a, b, c) {
        if (a == Array.prototype || a == Object.prototype) return a
        a[b] = c.value
        return a
      }
$jscomp.getGlobal = function (a) {
  a = [
    typeof globalThis === 'object' && globalThis,
    a,
    typeof window === 'object' && window,
    typeof self === 'object' && self,
    typeof global === 'object' && global,
  ]
  for (let b = 0; b < a.length; ++b) {
    const c = a[b]
    if (c && c.Math == Math) return c
  }
  throw Error('Cannot find global object')
}
$jscomp.global = $jscomp.getGlobal(this)
$jscomp.IS_SYMBOL_NATIVE =
  typeof Symbol === 'function' && typeof Symbol('x') === 'symbol'
$jscomp.TRUST_ES6_POLYFILLS =
  !$jscomp.ISOLATE_POLYFILLS || $jscomp.IS_SYMBOL_NATIVE
$jscomp.polyfills = {}
$jscomp.propertyToPolyfillSymbol = {}
$jscomp.POLYFILL_PREFIX = '$jscp$'
var $jscomp$lookupPolyfilledValue = function (a, b) {
  let c = $jscomp.propertyToPolyfillSymbol[b]
  if (c == null) return a[b]
  c = a[c]
  return void 0 !== c ? c : a[b]
}
$jscomp.polyfill = function (a, b, c, e) {
  b &&
    ($jscomp.ISOLATE_POLYFILLS
      ? $jscomp.polyfillIsolated(a, b, c, e)
      : $jscomp.polyfillUnisolated(a, b, c, e))
}
$jscomp.polyfillUnisolated = function (a, b, c, e) {
  c = $jscomp.global
  a = a.split('.')
  for (e = 0; e < a.length - 1; e++) {
    const d = a[e]
    if (!(d in c)) return
    c = c[d]
  }
  a = a[a.length - 1]
  e = c[a]
  b = b(e)
  b != e &&
    b != null &&
    $jscomp.defineProperty(c, a, { configurable: !0, writable: !0, value: b })
}
$jscomp.polyfillIsolated = function (a, b, c, e) {
  let d = a.split('.')
  a = d.length === 1
  e = d[0]
  e = !a && e in $jscomp.polyfills ? $jscomp.polyfills : $jscomp.global
  for (let f = 0; f < d.length - 1; f++) {
    const l = d[f]
    if (!(l in e)) return
    e = e[l]
  }
  d = d[d.length - 1]
  c = $jscomp.IS_SYMBOL_NATIVE && c === 'es6' ? e[d] : null
  b = b(c)
  b != null &&
    (a
      ? $jscomp.defineProperty($jscomp.polyfills, d, {
          configurable: !0,
          writable: !0,
          value: b,
        })
      : b !== c &&
        (($jscomp.propertyToPolyfillSymbol[d] = $jscomp.IS_SYMBOL_NATIVE
          ? $jscomp.global.Symbol(d)
          : $jscomp.POLYFILL_PREFIX + d),
        (d = $jscomp.propertyToPolyfillSymbol[d]),
        $jscomp.defineProperty(e, d, {
          configurable: !0,
          writable: !0,
          value: b,
        })))
}
$jscomp.polyfill(
  'Array.prototype.find',
  function (a) {
    return (
      a ||
      function (b, c) {
        return $jscomp.findInternal(this, b, c).v
      }
    )
  },
  'es6',
  'es3',
)
;(function (a) {
  typeof define === 'function' && define.amd
    ? define(['jquery', 'datatables.net'], function (b) {
        return a(b, window, document)
      })
    : typeof exports === 'object'
    ? (module.exports = function (b, c) {
        b || (b = window)
        ;(c && c.fn.dataTable) || (c = require('datatables.net')(b, c).$)
        return a(c, b, b.document)
      })
    : a(jQuery, window, document)
})(function (a, b, c, e) {
  const d = a.fn.dataTable
  a.extend(!0, d.defaults, {
    dom: "<'row'<'col-sm-12 col-md-6'l><'col-sm-12 col-md-6'f>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
    renderer: 'bootstrap',
  })
  a.extend(d.ext.classes, {
    sWrapper: 'dataTables_wrapper dt-bootstrap5',
    sFilterInput: 'form-control',
    sLengthSelect: 'form-select',
    sProcessing: 'dataTables_processing card',
    sPageButton: 'paginate_button page-item',
  })
  d.ext.renderer.pageButton.bootstrap = function (f, l, A, B, m, t) {
    const u = new d.Api(f)
    const C = f.oClasses
    const n = f.oLanguage.oPaginate
    const D = f.oLanguage.oAria.paginate || {}
    let h
    let k
    let v = 0
    var y = function (q, w) {
      let x
      const E = function (p) {
        p.preventDefault()
        a(p.currentTarget).hasClass('disabled') ||
          u.page() == p.data.action ||
          u.page(p.data.action).draw('page')
      }
      let r = 0
      for (x = w.length; r < x; r++) {
        const g = w[r]
        if (Array.isArray(g)) y(q, g)
        else {
          k = h = ''
          switch (g) {
            case 'ellipsis':
              h = '&#x2026;'
              k = 'disabled'
              break
            case 'first':
              h = n.sFirst
              k = g + (m > 0 ? '' : ' disabled')
              break
            case 'previous':
              h = n.sPrevious
              k = g + (m > 0 ? '' : ' disabled')
              break
            case 'next':
              h = n.sNext
              k = g + (m < t - 1 ? '' : ' disabled')
              break
            case 'last':
              h = n.sLast
              k = g + (m < t - 1 ? '' : ' disabled')
              break
            default:
              ;(h = g + 1), (k = m === g ? 'active' : '')
          }
          if (h) {
            const F = a('<li>', {
              class: `${C.sPageButton} ${k}`,
              id:
                A === 0 && typeof g === 'string' ? `${f.sTableId}_${g}` : null,
            })
              .append(
                a('<a>', {
                  'href': '#',
                  'aria-controls': f.sTableId,
                  'aria-label': D[g],
                  'data-dt-idx': v,
                  'tabindex': f.iTabIndex,
                  'class': 'page-link rounded',
                }).html(h),
              )
              .appendTo(q)
            f.oApi._fnBindAction(F, { action: g }, E)
            v++
          }
        }
      }
    }
    try {
      var z = a(l).find(c.activeElement).data('dt-idx')
    } catch (q) {}
    y(
      a(l)
        .empty()
        .html('<ul class="pagination pagination-flat"/>')
        .children('ul'),
      B,
    )
    z !== e && a(l).find(`[data-dt-idx=${z}]`).trigger('focus')
  }
  return d
})
